
<!--begin::Main-->
<ngx-spinner class="custom-spinner"
bdColor="rgba(255,255,255,1)"
  size="medium"
  color="#fff"
  type="ball-atom"
  [fullScreen]="true">
<span class="loader">
  <img src="/assets/media/logos/logo-wegestu-color.png" alt="">
</span>
</ngx-spinner>
<div class="app-main flex-column flex-row-fluid" id="kt_app_main">
  <!--begin::Content wrapper-->
  <div class="d-flex flex-column flex-column-fluid">

    <!--begin::Toolbar-->
    <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
      <!--begin::Toolbar container-->
      <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
        <!--begin::Page title-->
        <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
          <!--begin::Title-->
          <div class="masse d-flex align-items-center">
            <h1 class="page-heading"> 
              <svg width="32" height="29" viewBox="0 0 32 29" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_d_82_1744)">
                  <path
                    d="M21.795 7.11531C19.8257 7.11531 18.2199 5.51738 18.2199 3.55766C18.2199 1.59793 19.8257 0 21.795 0C23.7643 0 25.3701 1.59793 25.3701 3.55766C25.3701 5.51738 23.7643 7.11531 21.795 7.11531ZM16.3112 4.58274C16.3112 2.05017 14.2509 0.0301492 11.7363 0.0301492C9.19127 0.0301492 7.16135 2.08032 7.16135 4.58274C7.16135 7.11531 9.22157 9.13533 11.7363 9.13533C14.2812 9.13533 16.3112 7.08516 16.3112 4.58274ZM27.0667 15.9491C27.5212 15.9491 27.8848 15.5572 27.8242 15.105C27.3394 11.6076 25.8245 8.1404 21.795 8.1404C19.5227 8.1404 18.0381 9.25593 17.0989 10.8539C17.7654 11.4267 18.3714 12.09 18.8561 12.904C19.4015 13.7784 19.8863 14.8035 20.2498 15.9793H27.0667V15.9491ZM4.01041 19.2053C3.91952 19.8686 4.43457 20.5017 5.13142 20.5017H18.3411C19.0379 20.5017 19.553 19.8987 19.4621 19.2053C18.7956 14.8035 16.8565 10.4619 11.7363 10.4619C6.61599 10.4619 4.67695 14.8035 4.01041 19.2053Z"
                    fill="#265D91" />
                </g>
                <defs>
                  <filter id="filter0_d_82_1744" x="0" y="0" width="31.8308" height="28.5017"
                    filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha" />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_82_1744" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_82_1744" result="shape" />
                  </filter>
                </defs>
              </svg>
              Candidats
            </h1>
            <div class="tools">
              <div class="dropdown">
                <button class="masse-btn dropdown-toggle" type="button" id="dropdownMenuButton"
                  data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g filter="url(#filter0_d_588_1703)">
                      <circle cx="20" cy="18" r="13" fill="white" />
                    </g>
                    <path d="M19.6667 13V23" stroke="#265D91" stroke-width="2" stroke-linecap="round" />
                    <path d="M15 18.3333H25" stroke="#265D91" stroke-width="2" stroke-linecap="round" />
                    <defs>
                      <filter id="filter0_d_588_1703" x="0" y="0" width="42" height="42" filterUnits="userSpaceOnUse"
                        color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                          result="hardAlpha" />
                        <feOffset dx="1" dy="3" />
                        <feGaussianBlur stdDeviation="4" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0" />
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_588_1703" />
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_588_1703" result="shape" />
                      </filter>
                    </defs>
                  </svg>
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <a class="dropdown-item" (click)="openModal(add_candidat)">Ajout unitaire</a>
                  <a class="dropdown-item" (click)="downloadCsv()">Télécharger un modèle d'ajout en masse</a>
                  <a class="dropdown-item" (click)="openModalBulk(add_masse)">Ajout en masse</a>
                </div>
              </div>
            </div>

          </div>
          <!--end::Title-->
          <!--begin::Breadcrumb-->
          <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
            <!--begin::Item-->
            <li class="breadcrumb-item text-muted">
              <a class="text-muted" routerLink="/">Accueil</a>
            </li>
            <!--end::Item-->
            <!--begin::Item-->
            <li class="breadcrumb-item">
              <span class="bullet bg-gray-400 w-5px h-2px"></span>
            </li>
            <!--end::Item-->
            <!--begin::Item-->
            <li class="breadcrumb-item text-muted">Candidats</li>
            <!--end::Item-->
          </ul>
          <!--end::Breadcrumb-->
        </div>
        <!--end::Page title-->
        <!--begin::Actions-->

        <!--end::Actions-->
      </div>
      <!--end::Toolbar container-->
    </div>
    <!--end::Toolbar-->
    <div id="kt_app_content" class="app-content flex-column-fluid mb-4">
      <!--begin::Content container-->
      <div id="kt_app_content_container" class="app-container container-fluid">
        <!--begin::Card-->
        <div class="card mb-15">
          <!--begin::Card header-->
          <!-- (keyup.enter)="searchCandidate()" -->
          <div class="card-body tools" [formGroup]="searchFormGroup">
            <div class="title mb-3">
              <h4>Recherche</h4><br>

            </div>
            <div class="row">
              <div class="col-lg-6 mb-5">

                <div class="input-group search-libre">
                  <span class="input-group-text">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path
                        d="M19.7235 18.263L16.0223 14.5657C18.8541 11.0421 18.5809 5.83122 15.3515 2.63023C13.6625 0.942973 11.4019 0 8.9923 0C6.58271 0 4.34709 0.942973 2.63307 2.63023C0.943993 4.31749 0 6.5756 0 8.98259C0 11.3895 0.943993 13.6228 2.63307 15.3349C4.32216 17.0222 6.58271 17.9652 8.9923 17.9652C11.0293 17.9652 13.0165 17.2704 14.6063 16.005L18.3076 19.7023C18.5064 19.9008 18.7547 20 19.0032 20C19.2764 20 19.5249 19.9008 19.6987 19.7023C20.0962 19.2805 20.0962 18.6601 19.7235 18.2631L19.7235 18.263ZM15.9973 8.95782C15.9973 10.8189 15.2771 12.5807 13.9603 13.8958C12.6438 15.2109 10.88 15.9306 9.01701 15.9306C7.154 15.9306 5.39017 15.2111 4.0737 13.8958C2.75714 12.5806 2.03667 10.8188 2.03667 8.95782C2.03667 7.09682 2.75697 5.3349 4.0737 4.01985C5.39026 2.70472 7.154 1.98502 9.01701 1.98502C10.88 1.98502 12.6438 2.70454 13.9603 4.01985C15.2771 5.33499 15.9973 7.09682 15.9973 8.95782Z"
                        fill="#7E7C7C" />
                    </svg>
                  </span>
                  <input type="text" data-kt-customer-table-filter="search" class="form-control form-control-solid ps-5"
                    placeholder="Rechercher" formControlName="search"   (keyup.enter)="searchCandidate()"/>


                  <div class="tooltip-container tooltip-info">
                    <div class="tooltip-trigger"><i class="fa-solid fa-circle-info" style="font-size: 20px;"></i></div>
                    <div class="tooltip-content">
                      <div class="content">
                        <h4>Opérateur AND :</h4>
                        <p>Utilisez l'opérateur AND pour spécifier que les résultats doivent inclure plusieurs termes.
                        </p>
                        <p>Exemple : software AND engineer renverra des profils qui mentionnent à la fois "software" et
                          "engineer".
                        </p>
                        <h4>Opérateur OR :</h4>
                        <p>Utilisez l'opérateur OR pour spécifier que les résultats peuvent inclure l'un des termes.
                        </p>
                        <p>Exemple : sales OR marketing renverra des profils qui mentionnent soit "sales" soit
                          "marketing".
                        </p>
                        <h4>Opérateur NOT :</h4>
                        <p>Utilisez l'opérateur NOT pour exclure des termes spécifiques des résultats.
                        </p>
                        <p>Exemple : developer NOT manager renverra des profils qui mentionnent "developer" mais pas
                          "manager".
                        </p>
                        <h4>Guillemets pour une expression exacte :</h4>
                        <p>Utilisez des guillemets pour rechercher une expression exacte.
                        </p>
                        <p>Exemple : "product manager" renverra des profils qui mentionnent exactement "product
                          manager".
                        </p>
                        <h4>Parenthèses pour grouper des opérations :</h4>
                        <p>Utilisez des parenthèses pour définir l'ordre d'évaluation des opérations.
                        </p>
                        <p>Exemple : (sales OR marketing) AND manager renverra des profils qui mentionnent "sales" ou
                          "marketing" et "manager".
                        </p>
                        <h4>Recherche standard :</h4>
                        <p>Si aucun opérateur n'est spécifié dans la recherche, le texte sera interprété comme s'il
                          était entre guillemets.
                        </p>
                        <p>Exemple : La recherche product manager sera traitée comme "product manager", suivant la règle
                          4.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="text-danger mt-2"
                  *ngIf="searchFormGroup.get('search')?.hasError('pattern') && searchFormGroup.get('search')?.touched && isSimpleWord(searchFormGroup.get('search')?.value)">
                  Le modèle de recherche est invalide.
                </div> -->
              </div>

            </div>

            <div class="row mb-3">
              <div class="col-lg-6 col-xl-3">
                <input type="text" name="id" id="id" (change)="search=false;"
                  class="form-control form-control-solid mb-3" formControlName="ID_user" placeholder="ID">
              </div>
              <div class="col-lg-6 col-xl-3">
                <input type="text" name="nom" id="nom" (change)="search=false;" formControlName="first_name"
                  class="form-control form-control-solid mb-3" placeholder="prénom et Nom  ">
              </div>
              <div class="col-lg-6 col-xl-3">
                <input type="text" name="nom" id="nom" (change)="search=false;" formControlName="desired_workstation"
                  class="form-control form-control-solid mb-3" placeholder="Poste">
              </div>

              <div class="col-lg-6 col-xl-3  mb-3">
                <ng-select [items]="skillsList"  bindLabel="name_FR"
                  formControlName="skillsOr" bindValue="name_FR" 
                  [notFoundText]="'Aucun élément trouvé'" [multiple]="true" [placeholder]="'Compétences (ou)'"
                  autoComplete>
                </ng-select>

              </div>


            </div>
            <div class="row mb-3" *ngIf="seeMore">
              <div class="col-lg-6 col-xl-3  mb-3">
                <ng-select [items]="skillsList"  formControlName="skillsAnd"
                  bindLabel="name_FR" bindValue="name_FR" [multiple]="true" 
                  [notFoundText]="'Aucun élément trouvé'" [placeholder]="'Compétences (et)'"
                  autoComplete>
                </ng-select>
              </div>
              <div class="col-lg-6 col-xl-3">
                <input type="number" min="0" name="exper" (change)="search=false;"
                  formControlName="min_experience_years" id="experience_min"
                  class="form-control form-control-solid mb-3" placeholder=" Expérience min ">

              </div>
              <div class="col-lg-6 col-xl-3">
                <input type="number" min="0" name="exper" (change)="search=false;"
                  formControlName="max_experience_years" id="experience_max"
                  class="form-control form-control-solid mb-3" placeholder=" Expérience max">

              </div>
              <div class="col-lg-6 col-xl-3">
                <div class="combined-input mb-3">
                  <input type="number" name="number1" min="0" (change)="search=false;" formControlName="tjm"
                    (keypress)="keyPress($event)" class="nb1" placeholder="TJM" id="tjm">
                  <div class="euro">
                    <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M5.889 8.739C6.435 8.739 6.91167 8.62633 7.319 8.401C7.735 8.167 8.06 7.82467 8.294 7.374H10.075C9.737 8.24067 9.19533 8.908 8.45 9.376C7.70467 9.844 6.851 10.078 5.889 10.078C4.875 10.078 3.97367 9.805 3.185 9.259C2.39633 8.70433 1.846 7.96767 1.534 7.049H0.338V6.035H1.3C1.28267 5.79233 1.274 5.60167 1.274 5.463C1.274 5.32433 1.28267 5.13367 1.3 4.891H0.338V3.877H1.534C1.846 2.95833 2.39633 2.226 3.185 1.68C3.97367 1.12533 4.875 0.847999 5.889 0.847999C6.84233 0.847999 7.69167 1.08633 8.437 1.563C9.191 2.031 9.737 2.69833 10.075 3.565H8.294C8.06 3.11433 7.735 2.77633 7.319 2.551C6.91167 2.317 6.435 2.2 5.889 2.2C5.25633 2.2 4.69733 2.34733 4.212 2.642C3.73533 2.93667 3.37133 3.34833 3.12 3.877H5.889V4.891H2.834C2.808 5.073 2.795 5.26367 2.795 5.463C2.795 5.66233 2.808 5.853 2.834 6.035H5.889V7.049H3.12C3.37133 7.58633 3.73533 8.00233 4.212 8.297C4.69733 8.59167 5.25633 8.739 5.889 8.739Z"
                        fill="#4B4B4B" />
                    </svg>
                  </div>
                  <input type="number" min="0" (change)="search=false;" formControlName="tjm_range"
                    (keypress)="keyPress($event)" name="number2" class="nb2" value="1" id="marge_tjm">
                  <div class="icon">
                    <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M5.889 8.739C6.435 8.739 6.91167 8.62633 7.319 8.401C7.735 8.167 8.06 7.82467 8.294 7.374H10.075C9.737 8.24067 9.19533 8.908 8.45 9.376C7.70467 9.844 6.851 10.078 5.889 10.078C4.875 10.078 3.97367 9.805 3.185 9.259C2.39633 8.70433 1.846 7.96767 1.534 7.049H0.338V6.035H1.3C1.28267 5.79233 1.274 5.60167 1.274 5.463C1.274 5.32433 1.28267 5.13367 1.3 4.891H0.338V3.877H1.534C1.846 2.95833 2.39633 2.226 3.185 1.68C3.97367 1.12533 4.875 0.847999 5.889 0.847999C6.84233 0.847999 7.69167 1.08633 8.437 1.563C9.191 2.031 9.737 2.69833 10.075 3.565H8.294C8.06 3.11433 7.735 2.77633 7.319 2.551C6.91167 2.317 6.435 2.2 5.889 2.2C5.25633 2.2 4.69733 2.34733 4.212 2.642C3.73533 2.93667 3.37133 3.34833 3.12 3.877H5.889V4.891H2.834C2.808 5.073 2.795 5.26367 2.795 5.463C2.795 5.66233 2.808 5.853 2.834 6.035H5.889V7.049H3.12C3.37133 7.58633 3.73533 8.00233 4.212 8.297C4.69733 8.59167 5.25633 8.739 5.889 8.739Z"
                        fill="#4B4B4B" />
                    </svg>
                  </div>
                  <div class="plusetmois">
                    <i class="fa-solid fa-plus-minus"></i>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-xl-3">
                <div class="combined-input mb-3">
                  <input type="number" name="number1" (change)="search=false;alreadyConverted=false" min="0" (keypress)="keyPress($event)"
                    formControlName="desired_salary" class="nb1" placeholder="Salaire" id="Salaire">
                  <div class="euro">
                    <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M5.889 8.739C6.435 8.739 6.91167 8.62633 7.319 8.401C7.735 8.167 8.06 7.82467 8.294 7.374H10.075C9.737 8.24067 9.19533 8.908 8.45 9.376C7.70467 9.844 6.851 10.078 5.889 10.078C4.875 10.078 3.97367 9.805 3.185 9.259C2.39633 8.70433 1.846 7.96767 1.534 7.049H0.338V6.035H1.3C1.28267 5.79233 1.274 5.60167 1.274 5.463C1.274 5.32433 1.28267 5.13367 1.3 4.891H0.338V3.877H1.534C1.846 2.95833 2.39633 2.226 3.185 1.68C3.97367 1.12533 4.875 0.847999 5.889 0.847999C6.84233 0.847999 7.69167 1.08633 8.437 1.563C9.191 2.031 9.737 2.69833 10.075 3.565H8.294C8.06 3.11433 7.735 2.77633 7.319 2.551C6.91167 2.317 6.435 2.2 5.889 2.2C5.25633 2.2 4.69733 2.34733 4.212 2.642C3.73533 2.93667 3.37133 3.34833 3.12 3.877H5.889V4.891H2.834C2.808 5.073 2.795 5.26367 2.795 5.463C2.795 5.66233 2.808 5.853 2.834 6.035H5.889V7.049H3.12C3.37133 7.58633 3.73533 8.00233 4.212 8.297C4.69733 8.59167 5.25633 8.739 5.889 8.739Z"
                        fill="#4B4B4B" />
                    </svg>
                  </div>
                  <input type="number" min="0" (keypress)="keyPress($event)" (change)="search=false;alreadyConverted=false" (input)="onSalaryRangeInput($event)"
                    formControlName="desired_salary_range" name="number2" class="nb2" value="1" id="marge_tjm">
                  <div class="icon">
                    <svg width="20" height="15" viewBox="0 0 19 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M5.37 10L1.352 5.548V10H0.0780001V0.242H1.352V4.764L5.384 0.242H6.994L2.57 5.128L7.036 10H5.37Z"
                        fill="#4B4B4B" />
                      <path
                        d="M13.889 8.739C14.435 8.739 14.9117 8.62633 15.319 8.401C15.735 8.167 16.06 7.82467 16.294 7.374H18.075C17.737 8.24067 17.1953 8.908 16.45 9.376C15.7047 9.844 14.851 10.078 13.889 10.078C12.875 10.078 11.9737 9.805 11.185 9.259C10.3963 8.70433 9.846 7.96767 9.534 7.049H8.338V6.035H9.3C9.28267 5.79233 9.274 5.60167 9.274 5.463C9.274 5.32433 9.28267 5.13367 9.3 4.891H8.338V3.877H9.534C9.846 2.95833 10.3963 2.226 11.185 1.68C11.9737 1.12533 12.875 0.847999 13.889 0.847999C14.8423 0.847999 15.6917 1.08633 16.437 1.563C17.191 2.031 17.737 2.69833 18.075 3.565H16.294C16.06 3.11433 15.735 2.77633 15.319 2.551C14.9117 2.317 14.435 2.2 13.889 2.2C13.2563 2.2 12.6973 2.34733 12.212 2.642C11.7353 2.93667 11.3713 3.34833 11.12 3.877H13.889V4.891H10.834C10.808 5.073 10.795 5.26367 10.795 5.463C10.795 5.66233 10.808 5.853 10.834 6.035H13.889V7.049H11.12C11.3713 7.58633 11.7353 8.00233 12.212 8.297C12.6973 8.59167 13.2563 8.739 13.889 8.739Z"
                        fill="#4B4B4B" />
                    </svg>
                  </div>
                  <div class="plusetmois">
                    <i class="fa-solid fa-plus-minus"></i>
                  </div>
                </div>

              </div>
              <div class="col-lg-6 col-xl-3  mb-3">
                <ng-select [items]="contratRequest" 
                  formControlName="desired_contract" bindLabel="label" bindValue="id" [notFoundText]="'Aucun élément trouvé'" [multiple]="true"
                  (change)="search=false;" [placeholder]="'Contrat demandé'" autoComplete>
                </ng-select>
              </div>
              <div class="col-lg-6 col-xl-3">
                <div class="input-group mb-5">
                  <input type="number" min="0" formControlName="score" (change)="search=false;"
                    class="form-control mb-3" placeholder="Score" aria-label="Amount (to the nearest dollar)" />
                  <span class="input-group-text">%</span>
                </div>
              </div>
              <div class="col-lg-6 col-xl-3  mb-3">
                <ng-select formControlName="current_country"  [items]="paysList"
                  bindLabel="name" bindValue="name" [placeholder]="'Pays de résidence'" [notFoundText]="'Aucun élément trouvé'" autoComplete>
                </ng-select>
              </div>
              <div class="col-lg-6 col-xl-3  mb-3">
                <ng-select (change)="onCountryChangeSearch('add')" [items]="paysList" [multiple]="true"
                            [notFoundText]="'Aucun élément trouvé'"
                              id="pays_destinataire" bindLabel="name" bindValue="name" [placeholder]="'Pays'"
                              autoComplete formControlName="destination_country"
                              [notFoundText]="'Aucun élément trouvé'" autoComplete>
                              <ng-template ng-optgroup-tmp let-item="item">
                                {{ item.name || "Unnamed group" }}
                              </ng-template>
                            </ng-select>
              </div>
              <div class="col-lg-6 col-xl-3 mb-3">
                <ng-select #state [items]="stateList" [multiple]="true"
                              (change)="onMobilityChangeSearch('add')" id="mobilite" bindLabel="name"
                              formControlName="mobility" 
                              [notFoundText]="'Aucun élément trouvé'" bindValue="name" [placeholder]="'Mobilité'" autoComplete>
                            </ng-select>
              </div>
              <div class="col-lg-6 col-xl-3  mb-3">
                <!-- (change)="search=true;searchCandidate()" -->
                <ng-select [items]="statut"  formControlName="status"
                  bindLabel="name" bindValue="id" placeholder="Statut" [notFoundText]="'Aucun élément trouvé'" autoComplete>
                </ng-select>
              </div>
              <div class="col-lg-6 col-xl-3">
                <div class="position-relative d-flex align-items-center calenderDate">
                  <!--begin::Datepicker-->
             

<p-calendar [style]="{'border': 'none','margin-top': '-6px'}" dateFormat="dd/mm/yy"  inputId="yearpicker"
placeholder="Derniére maj"
formControlName="date_last_update"class="form-control"
                       ></p-calendar>
                  <!--end::Datepicker-->
                </div>
              </div>

            </div>

            <div class="see-more mb-5">
              <a class="" (click)="seeMore=!seeMore">Voir {{!seeMore?'plus':'moins'}} de critères de recherche</a>
            </div>
            <div class="mb-3 search-btn d-flex justify-content-end">
              <div class="align-items-center recherche">
                <button type="submit" class="me-5" (click)="search=true;searchCandidate()">
                  <svg width="15" height="15" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M19.7235 18.263L16.0223 14.5657C18.8541 11.0421 18.5809 5.83122 15.3515 2.63023C13.6625 0.942973 11.4019 0 8.9923 0C6.58271 0 4.34709 0.942973 2.63307 2.63023C0.943993 4.31749 0 6.5756 0 8.98259C0 11.3895 0.943993 13.6228 2.63307 15.3349C4.32216 17.0222 6.58271 17.9652 8.9923 17.9652C11.0293 17.9652 13.0165 17.2704 14.6063 16.005L18.3076 19.7023C18.5064 19.9008 18.7547 20 19.0032 20C19.2764 20 19.5249 19.9008 19.6987 19.7023C20.0962 19.2805 20.0962 18.6601 19.7235 18.2631L19.7235 18.263ZM15.9973 8.95782C15.9973 10.8189 15.2771 12.5807 13.9603 13.8958C12.6438 15.2109 10.88 15.9306 9.01701 15.9306C7.154 15.9306 5.39017 15.2111 4.0737 13.8958C2.75714 12.5806 2.03667 10.8188 2.03667 8.95782C2.03667 7.09682 2.75697 5.3349 4.0737 4.01985C5.39026 2.70472 7.154 1.98502 9.01701 1.98502C10.88 1.98502 12.6438 2.70454 13.9603 4.01985C15.2771 5.33499 15.9973 7.09682 15.9973 8.95782Z"
                      fill="white" />
                  </svg>
                  Rechercher</button>
              </div>
              <div class="resett-btn">
                <div class="reset-icon cursor-pointer" data-bs-toggle="tooltip" data-bs-placement="top"
                  title="Réinitialiser">
                  <a (click)="reset()"> <img src="/assets/media/icons/icon-reset.png" alt="" width="30px"></a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::Content container-->
      </div>
      <!--begin::Content-->

      <div id="kt_app_content" class="app-content flex-column-fluid mb-4">
        <!--begin::Content container-->
        <div id="kt_app_content_container" class="app-container container-fluid for-web">
          <!--begin::Card-->
          <div class="card">
            <div class="d-flex justify-content-between">
              <div class="section_title">
                <h1 class="section-heading my-0">Liste des candidats</h1>
              </div>
              <div class="d-flex flex-wrap flex-stack pt-10 pb-8 title">
                <div class="d-flex flex-wrap my-1">
                  <ul class="nav nav-pills me-5">
                    <li class="nav-item m-0">
                      <a class="btn btn-sm btn-icon btn-light btn-color-muted btn-active-primary me-3"
                        data-bs-toggle="tab" href="#grid">
                        <i class="ki-duotone ki-element-plus fs-1">
                          <span class="path1"></span>
                          <span class="path2"></span>
                          <span class="path3"></span>
                          <span class="path4"></span>
                          <span class="path5"></span>
                        </i>
                      </a>
                    </li>
                    <li class="nav-item m-0">
                      <a class="btn btn-sm btn-icon btn-light btn-color-muted btn-active-primary active"
                        data-bs-toggle="tab" href="#list">
                        <i class="ki-duotone ki-row-horizontal fs-2">
                          <span class="path1"></span>
                          <span class="path2"></span>
                        </i>
                      </a>
                    </li>
                  </ul>
                  <!--end::Tab nav-->
                </div>
                <!--end::Controls-->
              </div>
            </div>

            <!--begin::Card header buttons-->
            <div class="card-header border-0 pt-6 justify-content-end">

              <!--begin::Card toolbar-->
              <div class="card-toolbar ">
                <!--begin::Toolbar-->
                <div class="d-flex justify-content-end retest mb-3" data-kt-customer-table-toolbar="base">

                  <!--begin::Export-->
                  <button type="button" class="btn btn-light-primary me-3" (click)="dataCandidat('test','button')">
                    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M15.1817 1.60581L8.55619 8.73973L6.52003 5.91403C6.47435 5.8455 6.41539 5.78681 6.34663 5.74143C6.2773 5.69568 6.19943 5.66441 6.11771 5.64951C6.03598 5.6346 5.95209 5.63637 5.87107 5.65471C5.79005 5.67304 5.71357 5.70756 5.64623 5.7562C5.57888 5.80484 5.52206 5.86659 5.47919 5.93773C5.43631 6.00888 5.40825 6.08796 5.39671 6.17023C5.38516 6.25249 5.39036 6.33624 5.412 6.41645C5.43344 6.49594 5.47059 6.57033 5.52125 6.63522L7.99706 10.0728L7.99709 10.0728C8.05047 10.1469 8.11964 10.2081 8.19959 10.2522C8.27954 10.2963 8.36828 10.322 8.45939 10.3276L8.45938 10.3278H8.46551L8.49649 10.3278L8.4977 10.3278C8.58318 10.3268 8.6675 10.308 8.74532 10.2726C8.82284 10.2373 8.89222 10.1864 8.94908 10.1231L16.24 2.27618L16.2401 2.27611C16.2951 2.21675 16.3379 2.14713 16.3661 2.07122C16.3942 1.99532 16.4071 1.91461 16.4041 1.83371C16.401 1.75282 16.3821 1.67332 16.3483 1.59975C16.3145 1.52618 16.2666 1.45998 16.2072 1.40494L16.1392 1.47827L16.2072 1.40494C16.1478 1.3499 16.0782 1.30709 16.0023 1.27895C15.9264 1.25081 15.8457 1.2379 15.7648 1.24095C15.6839 1.24401 15.6044 1.26296 15.5308 1.29674C15.4573 1.33052 15.3911 1.37845 15.336 1.43781L15.1803 1.60581H15.1817Z"
                        fill="#265D91" stroke="#265D91" stroke-width="0.2" />
                      <path
                        d="M15.0282 6.48396L15.0281 6.48398C14.8679 6.5162 14.7271 6.6107 14.6365 6.7467C14.546 6.8827 14.5132 7.04908 14.5452 7.20928L14.5452 7.20936C14.6284 7.62282 14.6704 8.04349 14.6707 8.46523C14.6706 10.1278 14.0102 11.7223 12.8345 12.898C11.6589 14.0736 10.0644 14.7341 8.40174 14.7341C6.73911 14.7341 5.14459 14.0736 3.96893 12.898C2.79328 11.7223 2.13281 10.1278 2.13281 8.46516V8.46515C2.13271 7.37981 2.4144 6.31304 2.9503 5.36923C3.4862 4.42542 4.25796 3.63692 5.19004 3.08088C6.12213 2.52484 7.18261 2.22031 8.2677 2.19711C9.35275 2.1739 10.4252 2.43279 11.3802 2.94843C11.524 3.02675 11.6929 3.0448 11.85 2.99861C12.0071 2.95239 12.1395 2.84563 12.2179 2.70182C12.2964 2.55802 12.3145 2.38894 12.2682 2.23179C12.222 2.07464 12.1153 1.94229 11.9715 1.86385L11.9712 1.86368C10.5266 1.08223 8.86559 0.796416 7.24296 1.05011C5.62033 1.3038 4.12578 2.08297 2.98872 3.26804C1.85165 4.4531 1.13491 5.97857 0.948491 7.6103C0.762075 9.24203 1.11629 10.8899 1.95677 12.3008C2.79725 13.7118 4.07754 14.808 5.60115 15.4211C7.12475 16.0343 8.80746 16.1305 10.391 15.695C11.9746 15.2594 13.3714 14.3163 14.3672 13.0103C15.363 11.7043 15.9027 10.1075 15.9035 8.4652V8.46505C15.9029 7.96192 15.8527 7.46006 15.7535 6.96681C15.7212 6.80664 15.6267 6.66581 15.4908 6.57527C15.3548 6.48473 15.1884 6.45189 15.0282 6.48396Z"
                        fill="#265D91" stroke="#265D91" stroke-width="0.2" />
                    </svg>
                    Re-tester</button>
                  <!--end::Export-->
                  <!--begin::Add customer-->
                  <!--end::Add customer-->
                </div>
                <div class="d-flex justify-content-end revalider mb-3" data-kt-customer-table-toolbar="base">

                  <!--begin::Export-->
                  <button type="button" class="btn btn-light-primary me-3"
                    (click)="dataCandidat('validation','button')">
                    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M7.08446 1.31553L7.08582 1.31552C10.7751 1.31553 13.2476 4.46705 13.2476 7.42001C13.2476 7.57483 13.1855 7.72302 13.0754 7.83206C12.9653 7.94104 12.8164 8.00202 12.6614 8.00202C12.5064 8.00202 12.3575 7.94104 12.2474 7.83206C12.1373 7.72302 12.0752 7.57483 12.0752 7.42001C12.0752 5.03483 10.0669 2.47953 7.08437 2.4781L7.08446 1.31553ZM7.08446 1.31553C6.24363 1.32317 5.41292 1.4983 4.64175 1.83054C3.98531 2.11335 3.38341 2.5051 2.86164 2.98811L2.89308 1.50481C2.89309 1.50477 2.89309 1.50474 2.89309 1.50471C2.89645 1.34993 2.83758 1.20044 2.7299 1.08905C2.62223 0.977689 2.47462 0.913521 2.31963 0.910195C2.16464 0.906869 2.0144 0.964641 1.90201 1.07124C1.78957 1.17789 1.72422 1.32471 1.72084 1.47953L1.72083 1.47962M7.08446 1.31553L1.72083 1.47962M1.72083 1.47962L1.65541 4.55838L1.6554 4.5587M1.72083 1.47962L1.6554 4.5587M1.6554 4.5587C1.6539 4.63726 1.66844 4.71529 1.6981 4.78807C1.72755 4.86033 1.77128 4.9259 1.82663 4.98095C1.88215 5.03806 1.94917 5.08279 2.02323 5.11227C2.09729 5.14175 2.17675 5.15532 2.25641 5.15215L5.36328 5.08594L5.3633 5.08594M1.6554 4.5587L5.3633 5.08594M5.3633 5.08594C5.44007 5.08429 5.5158 5.06768 5.58618 5.03703M5.3633 5.08594L5.58618 5.03703M5.58618 5.03703C5.65656 5.00637 5.72025 4.96223 5.77357 4.90708M5.58618 5.03703L5.77357 4.90708M5.77357 4.90708C5.82689 4.85193 5.86879 4.78684 5.89682 4.71548M5.77357 4.90708L5.89682 4.71548M5.89682 4.71548C5.92485 4.64413 5.93843 4.56795 5.93675 4.49133M5.89682 4.71548L5.93675 4.49133M5.93675 4.49133C5.93508 4.4147 5.91818 4.33919 5.88706 4.26912M5.93675 4.49133L5.88706 4.26912M5.88706 4.26912C5.85595 4.19906 5.81125 4.13584 5.75558 4.08304M5.88706 4.26912L5.75558 4.08304M5.75558 4.08304C5.69992 4.03025 5.63438 3.9889 5.56275 3.9613M5.75558 4.08304L5.56275 3.9613M5.56275 3.9613C5.49111 3.93369 5.41473 3.92035 5.33796 3.922M5.56275 3.9613L5.33796 3.922M5.33796 3.922L5.33799 3.922L5.34118 4.07196C5.39846 4.07073 5.45542 4.08069 5.50881 4.10126C5.5622 4.12184 5.61098 4.15263 5.65236 4.19188L5.33796 3.922ZM5.33796 3.922L3.54147 3.96026M5.33796 3.922L3.54147 3.96026M3.54147 3.96026C4.36861 3.16771 5.60286 2.47812 7.0843 2.4781L3.54147 3.96026Z"
                        fill="#265D91" stroke="#265D91" stroke-width="0.3" />
                      <path
                        d="M7.01165 13.5245L7.01029 13.5245C3.32094 13.5245 0.85 10.3729 0.85 7.41998C0.85 7.26516 0.912108 7.11697 1.02219 7.00794C1.13223 6.89895 1.28116 6.83798 1.43616 6.83798C1.59116 6.83798 1.74009 6.89895 1.85013 7.00794C1.96021 7.11697 2.02232 7.26516 2.02232 7.41998C2.02232 9.80528 4.02934 12.3605 7.01029 12.3605C8.49302 12.3605 9.72742 11.6709 10.5557 10.8783L8.7596 10.9166L8.75957 10.9166L8.75638 10.7666C8.6991 10.7678 8.64214 10.7579 8.58875 10.7373C8.53536 10.7167 8.48658 10.6859 8.4452 10.6467C8.40382 10.6074 8.37065 10.5605 8.34759 10.5086C8.32452 10.4566 8.31201 10.4007 8.31077 10.3439C8.30953 10.2872 8.31958 10.2308 8.34035 10.1779C8.36113 10.125 8.39221 10.0767 8.43184 10.0357C8.47146 9.99474 8.51884 9.96189 8.57129 9.93904C8.62373 9.9162 8.6802 9.90381 8.73748 9.90258L7.01165 13.5245ZM7.01165 13.5245C7.85247 13.5168 8.68319 13.3417 9.45435 13.0095C10.1108 12.7266 10.7127 12.3349 11.2345 11.8519M7.01165 13.5245L11.2345 11.8519M11.2345 11.8519L11.203 13.3353L11.203 13.3354C11.2015 13.412 11.2152 13.4882 11.2433 13.5595L11.3828 13.5045L11.2433 13.5595C11.2714 13.6308 11.3135 13.6959 11.3669 13.7509C11.4203 13.806 11.4841 13.85 11.5545 13.8806C11.6249 13.9111 11.7007 13.9276 11.7775 13.9291L11.7775 13.9291H11.7804H11.7906C11.7906 13.9291 11.7906 13.9291 11.7906 13.9291C11.9436 13.9291 12.0908 13.8698 12.2004 13.7633C12.3101 13.6568 12.3736 13.5117 12.3767 13.3589L12.3767 13.3588L11.2345 11.8519ZM12.2704 9.85711C12.2147 9.80067 12.1478 9.75641 12.074 9.72705C12.0002 9.69769 11.9212 9.68385 11.8418 9.68639C11.8415 9.6864 11.8411 9.68641 11.8408 9.68642L12.2704 9.85711Z"
                        fill="#265D91" stroke="#265D91" stroke-width="0.3" />
                    </svg>
                    Re-valider</button>
                  <!--end::Export-->
                  <!--begin::Add customer-->
                  <!--end::Add customer-->
                </div>
                <div class="d-flex justify-content-end cv mb-3" data-kt-customer-table-toolbar="base">

                  <!--begin::Export-->
                  <button (click)="exportCVCandidate(null, 1, null)" type="button" class="btn btn-light-primary me-3">
                    <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M2.38333 13.1551H10.6167C10.9297 13.1551 11.2396 13.0917 11.5287 12.9685C11.8179 12.8453 12.0806 12.6648 12.3019 12.4371C12.5233 12.2095 12.6988 11.9392 12.8186 11.6418C12.9384 11.3444 13 11.0256 13 10.7037V7.36085C13 7.12443 12.9087 6.89769 12.7462 6.73051C12.5836 6.56334 12.3632 6.46942 12.1333 6.46942C11.9035 6.46942 11.683 6.56334 11.5205 6.73051C11.358 6.89769 11.2667 7.12443 11.2667 7.36085V10.7037C11.2667 10.881 11.1982 11.0511 11.0763 11.1765C10.9544 11.3018 10.7891 11.3723 10.6167 11.3723H2.38333C2.21094 11.3723 2.04561 11.3018 1.92371 11.1765C1.80182 11.0511 1.73333 10.881 1.73333 10.7037V7.36085C1.73333 7.12443 1.64202 6.89769 1.47949 6.73051C1.31696 6.56334 1.09652 6.46942 0.866667 6.46942C0.636812 6.46942 0.416372 6.56334 0.253841 6.73051C0.0913094 6.89769 0 7.12443 0 7.36085V10.7037C0 11.3539 0.2511 11.9774 0.698062 12.4371C1.14502 12.8969 1.75123 13.1551 2.38333 13.1551Z"
                        fill="#265D91" />
                      <path
                        d="M6.49986 0.0600586C6.27001 0.0600586 6.04957 0.153976 5.88704 0.321152C5.7245 0.488327 5.6332 0.715066 5.6332 0.951487V6.56526L4.31586 5.33954C4.14548 5.18085 3.92079 5.09827 3.69121 5.10997C3.46164 5.12167 3.24598 5.2267 3.0917 5.40194C2.93741 5.57719 2.85712 5.8083 2.86849 6.04444C2.87987 6.28057 2.98198 6.50239 3.15236 6.66109L5.9192 9.23509C5.93653 9.25069 5.95386 9.26183 5.9712 9.2752C5.98853 9.28857 6.01236 9.30863 6.03403 9.32423C6.05996 9.34055 6.08672 9.35542 6.1142 9.3688L6.1792 9.40223C6.21035 9.41454 6.24218 9.42496 6.27453 9.43343L6.3352 9.45126C6.44387 9.47395 6.55586 9.47395 6.66453 9.45126L6.7252 9.43343C6.75753 9.42493 6.78936 9.41451 6.82053 9.40223L6.88553 9.3688C6.913 9.35543 6.93977 9.34055 6.9657 9.32423C6.98736 9.30863 7.00686 9.29303 7.02853 9.2752C7.05019 9.25737 7.0632 9.25069 7.08053 9.23509L9.84736 6.66109C9.93173 6.58251 10.0002 6.48761 10.0489 6.3818C10.0976 6.276 10.1256 6.16136 10.1312 6.04444C10.1369 5.92752 10.1201 5.8106 10.0818 5.70036C10.0435 5.59012 9.98443 5.48872 9.90803 5.40194C9.83163 5.31517 9.73937 5.24472 9.6365 5.19463C9.53364 5.14453 9.42218 5.11576 9.30851 5.10997C9.19484 5.10417 9.08116 5.12147 8.97399 5.16086C8.86681 5.20025 8.76823 5.26097 8.68386 5.33954L7.36653 6.56526V0.951487C7.36653 0.715066 7.27522 0.488327 7.11269 0.321152C6.95016 0.153976 6.72972 0.0600586 6.49986 0.0600586Z"
                        fill="#265D91" />
                    </svg>
                    Télécharger CV</button>
                  <!--end::Export-->
                  <!--begin::Add customer-->
                  <!--end::Add customer-->
                </div>
                <div class="d-flex justify-content-end reponse mb-3" data-kt-customer-table-toolbar="base">

                  <!--begin::Export-->
                  <button (click)="downloadFiles('multiple',undefined,'response')" type="button"
                    class="btn btn-light-primary me-3">
                    <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M2.38333 13.1551H10.6167C10.9297 13.1551 11.2396 13.0917 11.5287 12.9685C11.8179 12.8453 12.0806 12.6648 12.3019 12.4371C12.5233 12.2095 12.6988 11.9392 12.8186 11.6418C12.9384 11.3444 13 11.0256 13 10.7037V7.36085C13 7.12443 12.9087 6.89769 12.7462 6.73051C12.5836 6.56334 12.3632 6.46942 12.1333 6.46942C11.9035 6.46942 11.683 6.56334 11.5205 6.73051C11.358 6.89769 11.2667 7.12443 11.2667 7.36085V10.7037C11.2667 10.881 11.1982 11.0511 11.0763 11.1765C10.9544 11.3018 10.7891 11.3723 10.6167 11.3723H2.38333C2.21094 11.3723 2.04561 11.3018 1.92371 11.1765C1.80182 11.0511 1.73333 10.881 1.73333 10.7037V7.36085C1.73333 7.12443 1.64202 6.89769 1.47949 6.73051C1.31696 6.56334 1.09652 6.46942 0.866667 6.46942C0.636812 6.46942 0.416372 6.56334 0.253841 6.73051C0.0913094 6.89769 0 7.12443 0 7.36085V10.7037C0 11.3539 0.2511 11.9774 0.698062 12.4371C1.14502 12.8969 1.75123 13.1551 2.38333 13.1551Z"
                        fill="#265D91" />
                      <path
                        d="M6.49986 0.0600586C6.27001 0.0600586 6.04957 0.153976 5.88704 0.321152C5.7245 0.488327 5.6332 0.715066 5.6332 0.951487V6.56526L4.31586 5.33954C4.14548 5.18085 3.92079 5.09827 3.69121 5.10997C3.46164 5.12167 3.24598 5.2267 3.0917 5.40194C2.93741 5.57719 2.85712 5.8083 2.86849 6.04444C2.87987 6.28057 2.98198 6.50239 3.15236 6.66109L5.9192 9.23509C5.93653 9.25069 5.95386 9.26183 5.9712 9.2752C5.98853 9.28857 6.01236 9.30863 6.03403 9.32423C6.05996 9.34055 6.08672 9.35542 6.1142 9.3688L6.1792 9.40223C6.21035 9.41454 6.24218 9.42496 6.27453 9.43343L6.3352 9.45126C6.44387 9.47395 6.55586 9.47395 6.66453 9.45126L6.7252 9.43343C6.75753 9.42493 6.78936 9.41451 6.82053 9.40223L6.88553 9.3688C6.913 9.35543 6.93977 9.34055 6.9657 9.32423C6.98736 9.30863 7.00686 9.29303 7.02853 9.2752C7.05019 9.25737 7.0632 9.25069 7.08053 9.23509L9.84736 6.66109C9.93173 6.58251 10.0002 6.48761 10.0489 6.3818C10.0976 6.276 10.1256 6.16136 10.1312 6.04444C10.1369 5.92752 10.1201 5.8106 10.0818 5.70036C10.0435 5.59012 9.98443 5.48872 9.90803 5.40194C9.83163 5.31517 9.73937 5.24472 9.6365 5.19463C9.53364 5.14453 9.42218 5.11576 9.30851 5.10997C9.19484 5.10417 9.08116 5.12147 8.97399 5.16086C8.86681 5.20025 8.76823 5.26097 8.68386 5.33954L7.36653 6.56526V0.951487C7.36653 0.715066 7.27522 0.488327 7.11269 0.321152C6.95016 0.153976 6.72972 0.0600586 6.49986 0.0600586Z"
                        fill="#265D91" />
                    </svg>
                    Télécharger Réponses</button>
                  <!--end::Export-->
                  <!--begin::Add customer-->
                  <!--end::Add customer-->
                </div>
                <div class="d-flex justify-content-end export mb-3" data-kt-customer-table-toolbar="base">

              
                  <button (click)="exportCandidats()" type="button" class="btn btn-light-primary me-3">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M5.85909 10.3268C5.29968 10.3268 4.74027 10.1071 4.31335 9.68234C3.45951 8.83288 3.45951 7.45618 4.31335 6.59207L7.94952 2.97455H2.56151C1.14826 2.97455 0 4.11692 0 5.52292V11.4106C0 12.8166 1.14826 13.9589 2.56151 13.9589H8.47949C9.89274 13.9589 11.041 12.8166 11.041 11.4106V6.07947L7.40483 9.69699C6.97791 10.1217 6.4185 10.3268 5.85909 10.3268Z"
                        fill="#265D91" />
                      <path
                        d="M13.1904 0.0600586H8.53843C8.09679 0.0600586 7.74347 0.411559 7.74347 0.850934C7.74347 1.29031 8.09679 1.64181 8.53843 1.64181H11.2913L5.29973 7.58802C4.99058 7.89558 4.99058 8.39354 5.29973 8.7011C5.44695 8.84756 5.65304 8.93544 5.85914 8.93544C6.06524 8.93544 6.25662 8.86221 6.41855 8.7011L12.4101 2.74025V5.47902C12.4101 5.91839 12.7634 6.2699 13.2051 6.2699C13.6467 6.2699 14 5.91839 14 5.47902V0.850934C13.9853 0.411559 13.632 0.0600586 13.1904 0.0600586Z"
                        fill="#265D91" />
                    </svg>
                    Exporter </button>
                  <!--end::Export-->
                  <!--begin::Add customer-->
                  <!--end::Add customer-->
                </div>
                <!--end::Toolbar-->

              </div>
              <!--end::Card toolbar-->
            </div>
            <!--end::Card header buttons-->
            <!--begin::Card body-->
            <div class="tab-content">
              <div id="grid" class="tab-pane fade">
                <!--begin::Row-->
                <div>
                  <div class="container">
                    <div class="row g-6 g-xl-9 cards" style="justify-content: center;">
                      <!--begin::Col-->
                      <div class="col-sm-6 col-xl-4" *ngFor="let cardCandidat of listCandidats; let i =index"
                        (click)="toggleRowSelection(cardCandidat)">
                        <!--begin::Card-->
                        <div class="card h-100">
                          <div class="form-check" style="margin: 17px;">
                            <input [checked]="cardCandidat.checked"
                              (change)="changeSelectCandidats($event,'single',cardCandidat)" class="form-check-input"
                              type="checkbox" value="" id="flexCheckDefault" />
                          </div>
                          <div class="card-toolbar m-0">

                            <!-- *********************************************************************** -->
                            <!-- begin menu action -->
                            <div class="tools mb-5">
                              <div class="dropdown" data-kt-menu-trigger="click" (click)="$event.stopPropagation()">
                                <button
                                  class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                                  type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true"
                                  aria-expanded="false">
                                  <svg width="19" height="5" viewBox="0 0 19 5" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="2.44739" cy="2.44739" r="2.44739" transform="matrix(1 0 0 -1 0 4.89478)"
                                      fill="#265D91" />
                                    <circle cx="2.44739" cy="2.44739" r="2.44739"
                                      transform="matrix(1 0 0 -1 6.85254 4.89478)" fill="#265D91" />
                                    <circle cx="2.44739" cy="2.44739" r="2.44739"
                                      transform="matrix(1 0 0 -1 13.7061 4.89478)" fill="#265D91" />
                                  </svg>
                                </button>
                               <div class="dropdown-table">
                                <div class="dropdown-menu " aria-labelledby="dropdownMenuButton">
                                  <a class="dropdown-item " (click)="navigateToProfilCandidat(cardCandidat.uuid)">Voir
                                    Profil</a>
                                  <a class="dropdown-item " 
                                    (click)="dataCandidat('validation','row',cardCandidat)">Re-valider</a>
                                  <a class="dropdown-item " 
                                    (click)="dataCandidat('test','row',cardCandidat)">Re-tester</a>
                                </div>
                               </div>
                              </div>
                            </div>
                            <!-- end menu action -->
                            <!-- *********************************************************************** -->
                          </div>
                          <!--begin::Card header-->
                          <!--begin::Card header-->
                          <div class="border-0">
                            <!--begin::Card title-->
                            <div class="card-title">
                              <!--begin::Icon-->
                              <div class="img-candidat text-center mb-5">
                                <a [routerLink]="['/acceuil/candidats/profil-candidat', { idCandidat: cardCandidat.uuid }]">
                                  <img *ngIf="cardCandidat.image_url&&cardCandidat.image_url!='avatar.png'&&cardCandidat.image_url!='undefined'"
                                    class="table-img cursor-pointer"
                                    src="{{url+'/User/file/gallery_users/' + cardCandidat.image_url}}" alt="" width="75px">
                                  <img
                                    *ngIf="!cardCandidat.image_url||cardCandidat.image_url&&(cardCandidat.image_url=='avatar.png'||cardCandidat.image_url=='undefined')"
                                    class="table-img cursor-pointer" src="/assets/media/logos/logo-avatar.jpg" alt="" width="75px"
                                    (click)="navigateToProfilCandidat(cardCandidat.uuid)">
                                </a>
                              </div>
                              <!--end::Icon-->
                              <!--begin::Title-->
                              <div class="header-info mb-10">
                                <a class="name cursor-pointer"
                                  [routerLink]="['/acceuil/candidats/profil-candidat', { idCandidat: cardCandidat.uuid }]">{{cardCandidat.first_name ? cardCandidat.first_name :'---'}} {{cardCandidat.last_name ? cardCandidat.last_name:'---'}} 
                                  </a>
                                <span>
                                  {{cardCandidat.desired_workstation && cardCandidat.desired_workstation!='null' ? cardCandidat.desired_workstation:'---'}}</span>
                                <span> {{cardCandidat.years_of_experience?cardCandidat.years_of_experience:'---'}}
                                  D'experience.</span>
                              </div>
                              <!--end::Title-->
                              <div class="infos">

                                <p *ngIf="cardCandidat.desired_salary&&cardCandidat.desired_salary!='null'&&cardCandidat.desired_salary!=='0'" class="sub-info">Salaire :{{cardCandidat.desired_salary +'€'}}</p>
                                <p *ngIf="cardCandidat.tjm&&cardCandidat.tjm!='null'&&cardCandidat.tjm!=='0'" class="sub-info">TJM : {{cardCandidat.tjm +' €'}}</p>
                              </div>
                            </div>
                          </div>
                          <!--end::Card header-->
                          <!--begin::Card body-->
                          <div class="card-body d-flex flex-column px-9 pt-6 pb-8">
                            <div class="footer">
                              <div class="details">
                                <a class="cursor-pointer" (click)="navigateToProfilCandidat(cardCandidat.uuid); $event.stopPropagation()">Voir
                                  détail</a>
                              </div>
                            </div>
                            <!--end::Indicator-->
                          </div>
                          <!--end::Card body-->
                          <!--end::Card body-->
                        </div>
                        <!--end::Card-->
                      </div>
                      <!--end::Col-->
                    </div>
                  </div>
                </div>

                <!--end::Row-->

              </div>
              <div id="list" class="tab-pane fade active show">
                <div class="card-body pt-0">
                  <!--begin::Table-->

                    <div class="table-responsive mb-4 "  id="kt_customers_table">
                      <table *ngIf="!loadSpinnerTable&&listCandidats.length" class="table align-middle fs-6 gy-5 mb-4"
                       >
                        <thead>
                          <tr class="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
                            <th *ngIf="listNames.length" class="min-w-50px">
                              <div class="form-check">
                                <input (change)="changeSelectCandidats($event,'allCandidats'); $event.stopPropagation()"
                                  class="form-check-input" [checked]="headerChecked" type="checkbox" value=""
                                  id="flexCheckDefault" />

                              </div>
                            </th>

                            <ng-container *ngFor="let item of listNames ;let i =index">
                              <th class="min-w-225px" [ngClass]="{'th-fixed': item === 'Nom'}">
                                <span>{{item}}</span>
                                <i *ngIf="!['CV','Image','CV WegestU'].includes(item)" (click)="sortData(item)"
                                  class="fa-solid fa-sort cursor-pointer"></i>
                              </th>
                            </ng-container>
                            <th *ngIf="listNames.length" class="min-w-125px"><span>Actions</span></th>
                            <th class="min-w-70px">
                              <div class="tools-column">
                                <div class="dropdown" >
                                  <button class="elimiate-btn dropdown-toggle" type="button" id="dropdownMenuButton"
                                    data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-kt-menu-trigger="click">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28"
                                      fill="none">
                                      <g filter="url(#filter0_d_588_1699)">
                                        <rect x="4" width="20" height="20" rx="4" fill="#63C3E8" fill-opacity="0.12"
                                          shape-rendering="crispEdges" />
                                      </g>
                                      <path
                                        d="M17.5 10.6H14.6V13.5C14.6 13.8314 14.3314 14.1 14 14.1C13.6686 14.1 13.4 13.8314 13.4 13.5V10.6H10.5C10.1686 10.6 9.9 10.3314 9.9 10C9.9 9.66863 10.1686 9.4 10.5 9.4H13.4V6.5C13.4 6.16863 13.6686 5.9 14 5.9C14.3314 5.9 14.6 6.16863 14.6 6.5V9.4H17.5C17.8314 9.4 18.1 9.66863 18.1 10C18.1 10.3314 17.8314 10.6 17.5 10.6Z"
                                        fill="#265D91" stroke="#265D91" stroke-width="0.2" />
                                      <defs>
                                        <filter id="filter0_d_588_1699" x="0" y="0" width="28" height="28"
                                          filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                          <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                          <feColorMatrix in="SourceAlpha" type="matrix"
                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                          <feOffset dy="4" />
                                          <feGaussianBlur stdDeviation="2" />
                                          <feComposite in2="hardAlpha" operator="out" />
                                          <feColorMatrix type="matrix"
                                            values="0 0 0 0 0.14902 0 0 0 0 0.364706 0 0 0 0 0.568627 0 0 0 0.13 0" />
                                          <feBlend mode="normal" in2="BackgroundImageFix"
                                            result="effect1_dropShadow_588_1699" />
                                          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_588_1699"
                                            result="shape" />
                                        </filter>
                                      </defs>
                                    </svg>
                                  </button>
                                 <div class="list-actions">
                                  <div class="dropdown-menu eliminate" aria-labelledby="dropdownMenuButton">
                                    <div class="d-flex checkbox mb-2 menu" *ngFor="let item of dataHeader;let i =index">
                                      <div class="form-check form-check-sm form-check-custom form-check-solid"
                                        *ngIf="item.name!='checkbox'">

                                        <input class="form-check-input checkbox-border"
                                          [checked]="(item.checked=='oui'&&!item.checked_user)||item.checked_user=='oui'&&(item.checked=='non'||item.checked=='oui')"
                                          (change)="changeSelection($event,item,i)" type="checkbox" value="1"  [disabled]="item.name==='Nom' || item.name==='Image'"/>
                                        <a class="dropdown-item">{{item.name}}</a>
                                      </div>
                                    </div>
                                  </div>
                                 </div>
                                </div>
                              </div>

                            </th>
                          </tr>
                        </thead>
                        <tbody class="fw-semibold text-gray-600">
                          <tr *ngFor="let data of listCandidats;let i =index" (click)="toggleRowSelection(data)">
                            <td (click)="$event.stopPropagation()">
                              <div class="form-check">
                                <input [checked]="data.checked" (change)="changeSelectCandidats($event,'single',data)"
                                  class="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                              </div>
                            </td>

                            <td *ngIf="listNames?.includes('ID')">
                              <a [routerLink]="['/acceuil/candidats/profil-candidat', { idCandidat: data.uuid }]">
                                <span class="first-td">{{data.ID_user?data.ID_user:'---'}}</span>
                              </a>
                            </td>
                            <td *ngIf="listNames?.includes('Image')">
                              <a [routerLink]="['/acceuil/candidats/profil-candidat', { idCandidat: data.uuid }]">
                                <img *ngIf="data.image_url&&data.image_url!='avatar.png'&&data.image_url!='undefined'"
                                  class="table-img cursor-pointer"
                                  src="{{url+'/User/file/gallery_users/' + data.image_url}}" alt="" width="75px">
                                <img
                                  *ngIf="!data.image_url||data.image_url&&(data.image_url=='avatar.png'||data.image_url=='undefined')"
                                  class="table-img cursor-pointer" src="/assets/media/logos/logo-avatar.jpg" alt="" width="75px"
                                  (click)="navigateToProfilCandidat(data.uuid)">
                              </a>
                            </td>

                            <td *ngIf="listNames?.includes('Nom')" class="wrapping td-fixed"><a
                                [routerLink]="['/acceuil/candidats/profil-candidat', { idCandidat: data.uuid }]"
                                class=" mb-1 cursor-pointer"><span class="name first-td">{{data.first_name?data.first_name:'---'}} {{data.last_name?data.last_name:'---'}} 
                                 </span> </a>
                            </td>
                            <td *ngIf="listNames?.includes('Poste')" class="wrapping">
                              <span class="poste-wrap">{{data.desired_workstation && data.desired_workstation!='null' ? data.desired_workstation:'---'}}  </span>
                            </td>
                            <td *ngIf="listNames?.includes('Disponibilité')" class="wrapping">
                              <span class="poste-wrap">
                                {{data.availability=='1'?'Immédiate':data.availability=='2'? '1 mois':data.availability=='3'?'2 mois':data.availability=='4'?'3 mois':data.availability=='5'?'4 mois':data.availability=='6'?'5 mois':'---'}}
                              </span>
                            </td>

                            <td *ngIf="listNames?.includes('Expérience')" class="wrapping">
                              <span class="poste-wrap">{{data.years_of_experience}}</span>
                            </td>

                            <td *ngIf="listNames?.includes('TJM')" class="wrapping">
                              <span class="poste-wrap">{{data.tjm&&data.tjm!='null'&&data.tjm!=='0'?data.tjm +' €':'---'}}</span>
                            </td>
                            <td *ngIf="listNames?.includes('Salaire souhaité')" class="wrapping">
                              <span class="poste-wrap">{{data.desired_salary&&data.desired_salary!='null'&&data.desired_salary!=='0'?data.desired_salary +'
                                €':'---'}}</span>
                            </td>

                            <td *ngIf="listNames.includes('Contrat demandé')" class="wrapping">
                              <!-- class="list-type" -->
                              <div  *ngIf="data?.desired_contract?.length">
                                <ng-container *ngFor="let type of data?.desired_contract?.slice(0,3)">
                                  <div *ngIf="type == '1'" class="text-gray-600 fw-semibold"><span>Alternance</span></div>
                                  <div *ngIf="type == '2'" class="text-gray-600 fw-semibold"><span>Autres type de contrat</span></div>
                                  <div *ngIf="type == '3'" class="text-gray-600 fw-semibold"><span>CDD</span></div>
                                  <div *ngIf="type == '4'" class="text-gray-600 fw-semibold"><span>CDI</span></div>
                                  <div *ngIf="type == '5'" class="text-gray-600 fw-semibold"><span>Freelance</span></div>
                                  <div *ngIf="type == '6'" class="text-gray-600 fw-semibold"><span>Portage salarial</span></div>
                                  <div *ngIf="type == '7'" class="text-gray-600 fw-semibold"><span>Stage</span></div>
                                </ng-container>
                                <div *ngIf="hasMoreThanThreeContracts(data?.desired_contract)" class="text-gray-600 fw-semibold"><span>...</span></div>
                              </div>
                              <span *ngIf="!data?.desired_contract?.length">---</span>
                            </td>
                            
                            
                            
                            <td *ngIf="listNames?.includes('N°Tel')" class="wrapping">
                              <span class="poste-wrap">{{data.phone_number && data.phone_number !== 'undefined' && data.phone_number !==
                                'null' ? data.phone_number:'---'}}</span>
                            </td>

                            <td *ngIf="listNames.includes('Email')" class="wrapping">
                              <span class="poste-wrap"> {{data.email?data.email:'---'}}</span>
                            </td>
                            <td *ngIf="listNames.includes('ESN')" class="wrapping">
                              <span class="poste-wrap">{{data.ESN_name?data.ESN_name:'---'}}</span>
                            </td>

                            <td *ngIf="listNames.includes('Client')" class="wrapping">
                              <span class="poste-wrap">{{data.ClientFinal_names?data.ClientFinal_names:'---'}}</span>
                            </td>


                            <td *ngIf="listNames.includes('Pays de résidence')" class="wrapping">
                              <span class="poste-wrap">{{data.current_country && data.current_country!='null' ? data.current_country:'---'}}</span>
                            </td>
                            <td *ngIf="listNames.includes('Pays Destinataire')" class="wrapping">
                              <span class="poste-wrap">{{data.destination_country && data.destination_country?.length ? data.destination_country:'---'}}</span>
                            </td>
                            <td *ngIf="listNames.includes('Mobilité')" class="wrapping">
                              <span class="poste-wrap">{{data.mobility && data.mobility?.length ? data.mobility:'---'}}</span>

                            </td>
                            <td *ngIf="listNames.includes('Dernière connexion')" class="wrapping">
                              <span *ngIf="!data.last_connection" class="poste-wrap">---</span>
                              <span *ngIf="data.last_connection" class="poste-wrap">{{ cleanDate(data.last_connection!) | formatDate }}</span>
                            </td>
                            <td *ngIf="listNames.includes('Dernière MAJ')" class="wrapping">
                              <span *ngIf="!data.date_last_update" class="poste-wrap">---</span>
                              <span *ngIf="data.date_last_update" class="poste-wrap">{{ cleanDate(data.date_last_update!) | formatDate }}</span>
                            </td>
                            <td *ngIf="listNames.includes('CV')">
                              <a *ngIf="data.cv&&data.cv!='null'" class="file-cursor"
                                (click)="downloadCVOriginal(data)"><svg width="26"
                                  height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M25.4273 4.11964V21.4987C25.4273 22.575 24.9783 23.6084 24.1801 24.3693C23.382 25.1302 22.2981 25.5583 21.1692 25.5583H4.25806C3.12915 25.5583 2.04528 25.1302 1.24716 24.3693C0.449034 23.6084 0 22.575 0 21.4987V4.11964C0 3.04334 0.449034 2.01001 1.24716 1.24908C2.04528 0.488163 3.12915 0.0600586 4.25806 0.0600586H21.1692C22.2981 0.0600586 23.382 0.488163 24.1801 1.24908C24.9783 2.01001 25.4273 3.04334 25.4273 4.11964ZM11.7058 19.8279C12.1182 20.197 12.7193 20.2896 13.2288 20.0802C13.3766 20.0185 13.5118 19.9339 13.6314 19.8279L17.8543 16.0528C18.4216 15.5469 18.4497 14.696 17.919 14.1566C17.387 13.6157 16.4959 13.5875 15.9287 14.0948L14.0762 15.7509V6.77012C14.0762 6.02933 13.4456 5.42811 12.6686 5.42811C11.8916 5.42811 11.261 6.02933 11.261 6.77012V15.7509L9.40855 14.0948C8.84127 13.5875 7.95025 13.6157 7.41817 14.1566C6.88749 14.696 6.91565 15.5469 7.48292 16.0528L11.7058 19.8279Z"
                                    fill="#F58F29" />
                                </svg>
                              </a>
                              <span *ngIf="!data.cv||data.cv=='null'">---</span>
                            </td>
                            <td *ngIf="listNames.includes('CV WegestU')">
                              <a class="file-cursor" (click)="exportCVCandidate(data, 1, null)"><svg width="26" height="26"
                                  viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M25.4273 4.11964V21.4987C25.4273 22.575 24.9783 23.6084 24.1801 24.3693C23.382 25.1302 22.2981 25.5583 21.1692 25.5583H4.25806C3.12915 25.5583 2.04528 25.1302 1.24716 24.3693C0.449034 23.6084 0 22.575 0 21.4987V4.11964C0 3.04334 0.449034 2.01001 1.24716 1.24908C2.04528 0.488163 3.12915 0.0600586 4.25806 0.0600586H21.1692C22.2981 0.0600586 23.382 0.488163 24.1801 1.24908C24.9783 2.01001 25.4273 3.04334 25.4273 4.11964ZM11.7058 19.8279C12.1182 20.197 12.7193 20.2896 13.2288 20.0802C13.3766 20.0185 13.5118 19.9339 13.6314 19.8279L17.8543 16.0528C18.4216 15.5469 18.4497 14.696 17.919 14.1566C17.387 13.6157 16.4959 13.5875 15.9287 14.0948L14.0762 15.7509V6.77012C14.0762 6.02933 13.4456 5.42811 12.6686 5.42811C11.8916 5.42811 11.261 6.02933 11.261 6.77012V15.7509L9.40855 14.0948C8.84127 13.5875 7.95025 13.6157 7.41817 14.1566C6.88749 14.696 6.91565 15.5469 7.48292 16.0528L11.7058 19.8279Z"
                                    fill="#F58F29" />
                                </svg>
                              </a>
                            </td>
                            <td *ngIf="listNames.includes('Score')">

                              <div *ngIf="data.score!=null">
                                <div class="progress">
                                  <div class="progress-bar bg-success" role="progressbar" [style.width.%]="data.score"
                                    [attr.aria-valuenow]="data.score" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                                <span *ngIf="data.score!=null">{{data.score +' %'}}</span>
                              </div>


                              <span *ngIf="data.score==null">---</span>

                            </td>
                            <td *ngIf="listNames.includes('Réponses')"><a *ngIf="data?.file_test"
                                (click)="downloadFiles('single',data,'response'); $event.stopPropagation()"
                                class="file-cursor"><svg width="26" height="26" viewBox="0 0 26 26" fill="none"
                                  xmlns="http://www.w3.org/2000/svg">
                                  <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M25.4273 4.11964V21.4987C25.4273 22.575 24.9783 23.6084 24.1801 24.3693C23.382 25.1302 22.2981 25.5583 21.1692 25.5583H4.25806C3.12915 25.5583 2.04528 25.1302 1.24716 24.3693C0.449034 23.6084 0 22.575 0 21.4987V4.11964C0 3.04334 0.449034 2.01001 1.24716 1.24908C2.04528 0.488163 3.12915 0.0600586 4.25806 0.0600586H21.1692C22.2981 0.0600586 23.382 0.488163 24.1801 1.24908C24.9783 2.01001 25.4273 3.04334 25.4273 4.11964ZM11.7058 19.8279C12.1182 20.197 12.7193 20.2896 13.2288 20.0802C13.3766 20.0185 13.5118 19.9339 13.6314 19.8279L17.8543 16.0528C18.4216 15.5469 18.4497 14.696 17.919 14.1566C17.387 13.6157 16.4959 13.5875 15.9287 14.0948L14.0762 15.7509V6.77012C14.0762 6.02933 13.4456 5.42811 12.6686 5.42811C11.8916 5.42811 11.261 6.02933 11.261 6.77012V15.7509L9.40855 14.0948C8.84127 13.5875 7.95025 13.6157 7.41817 14.1566C6.88749 14.696 6.91565 15.5469 7.48292 16.0528L11.7058 19.8279Z"
                                    fill="#F58F29" />
                                </svg>
                              </a>
                              <span *ngIf="!data.file_test">---</span>
                            </td>

                            <td *ngIf="listNames.includes('Statut')" class="wrapping">
                              <span class="recrute" *ngIf="data.status">
                                {{data.status==1?'Non Réclamé':data.status==2?'Réclamé':data.status==3
                                ?'Validé et non notifié':data.status==4?'Validé et notifié':'Validé et testé'}}</span>
                              <span *ngIf="!data.status">---</span>
                              
                            </td>
                            <!--end::Menu-->
                            <td *ngIf="listNames.length">
                              <div class="tools">
                                <div class="dropdown">
                                  <button
                                    class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                                    type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true"
                                    aria-expanded="false">
                                    <svg width="19" height="5" viewBox="0 0 19 5" fill="none"
                                      xmlns="http://www.w3.org/2000/svg">
                                      <circle cx="2.44739" cy="2.44739" r="2.44739"
                                        transform="matrix(1 0 0 -1 0 4.89478)" fill="#265D91" />
                                      <circle cx="2.44739" cy="2.44739" r="2.44739"
                                        transform="matrix(1 0 0 -1 6.85254 4.89478)" fill="#265D91" />
                                      <circle cx="2.44739" cy="2.44739" r="2.44739"
                                        transform="matrix(1 0 0 -1 13.7061 4.89478)" fill="#265D91" />
                                    </svg>
                                  </button>
                                 <div class="dropdown-table">
                                  <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    <a class="dropdown-item" (click)="navigateToProfilCandidat(data.uuid)">Voir profil</a>
                                    <a class="dropdown-item"
                                      (click)="dataCandidat('validation','row',data)">Re-valider</a>
                                    <a class="dropdown-item" (click)="dataCandidat('test','row',data)">Re-tester</a>
                                  </div>
                                 </div>
                                </div>
                              </div>
                            </td>
                          </tr>

                        </tbody>
                      </table>
                    </div>
                
                    <div class="alert alert-warning text-center mt-5" role="alert"
                    *ngIf="!listCandidats.length && !loadSpinnerTable">
                    <img src="/assets/media/logos/logo-no-data.png" alt="" class="mb-5">
                    <span class="empty-list">
                      La liste est vide
                    </span>
                  </div>
                  <div class="pagination" *ngIf="listCandidats && listCandidats.length">
                    <app-pagination [data]="listCandidats" [lengthData]="totalItems" [currentPageList]="currentPage"  [endexPageList]="endIndex"
                      (setPages)="getItems($event)"> </app-pagination>
                  </div>
                  <!--end::Table-->
                </div>
                <!--end::Card body-->
              </div>
            </div>
           
          </div>
          <!-- -->
          <!--end::Card-->
          <!--begin::Modals-->
          <!--begin::Modal - Customers - Add-->

          <!--end::Modal - Customers - Add-->
          <!--begin::Modal - Adjust Balance-->


          <!--end::Modal - New Card-->
          <!--end::Modals-->
        </div>
        <div  id="kt_app_content_container" class="app-container container-fluid for-mobile">
          <!--begin::Card-->
          <div class="card">
            <div class="d-flex justify-content-between">
              <div class="section_title">
                <h1 class="section-heading my-0">Liste des candidats</h1>
              </div>
            
            </div>

            <!--begin::Card header buttons-->
            <div class="card-header border-0 pt-6 justify-content-end">

              <!--begin::Card toolbar-->
              <div class="card-toolbar ">
                <!--begin::Toolbar-->
                <div class="d-flex justify-content-end retest mb-3" data-kt-customer-table-toolbar="base">

                  <!--begin::Export-->
                  <button type="button" class="btn btn-light-primary me-3" (click)="dataCandidat('test','button')">
                    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M15.1817 1.60581L8.55619 8.73973L6.52003 5.91403C6.47435 5.8455 6.41539 5.78681 6.34663 5.74143C6.2773 5.69568 6.19943 5.66441 6.11771 5.64951C6.03598 5.6346 5.95209 5.63637 5.87107 5.65471C5.79005 5.67304 5.71357 5.70756 5.64623 5.7562C5.57888 5.80484 5.52206 5.86659 5.47919 5.93773C5.43631 6.00888 5.40825 6.08796 5.39671 6.17023C5.38516 6.25249 5.39036 6.33624 5.412 6.41645C5.43344 6.49594 5.47059 6.57033 5.52125 6.63522L7.99706 10.0728L7.99709 10.0728C8.05047 10.1469 8.11964 10.2081 8.19959 10.2522C8.27954 10.2963 8.36828 10.322 8.45939 10.3276L8.45938 10.3278H8.46551L8.49649 10.3278L8.4977 10.3278C8.58318 10.3268 8.6675 10.308 8.74532 10.2726C8.82284 10.2373 8.89222 10.1864 8.94908 10.1231L16.24 2.27618L16.2401 2.27611C16.2951 2.21675 16.3379 2.14713 16.3661 2.07122C16.3942 1.99532 16.4071 1.91461 16.4041 1.83371C16.401 1.75282 16.3821 1.67332 16.3483 1.59975C16.3145 1.52618 16.2666 1.45998 16.2072 1.40494L16.1392 1.47827L16.2072 1.40494C16.1478 1.3499 16.0782 1.30709 16.0023 1.27895C15.9264 1.25081 15.8457 1.2379 15.7648 1.24095C15.6839 1.24401 15.6044 1.26296 15.5308 1.29674C15.4573 1.33052 15.3911 1.37845 15.336 1.43781L15.1803 1.60581H15.1817Z"
                        fill="#265D91" stroke="#265D91" stroke-width="0.2" />
                      <path
                        d="M15.0282 6.48396L15.0281 6.48398C14.8679 6.5162 14.7271 6.6107 14.6365 6.7467C14.546 6.8827 14.5132 7.04908 14.5452 7.20928L14.5452 7.20936C14.6284 7.62282 14.6704 8.04349 14.6707 8.46523C14.6706 10.1278 14.0102 11.7223 12.8345 12.898C11.6589 14.0736 10.0644 14.7341 8.40174 14.7341C6.73911 14.7341 5.14459 14.0736 3.96893 12.898C2.79328 11.7223 2.13281 10.1278 2.13281 8.46516V8.46515C2.13271 7.37981 2.4144 6.31304 2.9503 5.36923C3.4862 4.42542 4.25796 3.63692 5.19004 3.08088C6.12213 2.52484 7.18261 2.22031 8.2677 2.19711C9.35275 2.1739 10.4252 2.43279 11.3802 2.94843C11.524 3.02675 11.6929 3.0448 11.85 2.99861C12.0071 2.95239 12.1395 2.84563 12.2179 2.70182C12.2964 2.55802 12.3145 2.38894 12.2682 2.23179C12.222 2.07464 12.1153 1.94229 11.9715 1.86385L11.9712 1.86368C10.5266 1.08223 8.86559 0.796416 7.24296 1.05011C5.62033 1.3038 4.12578 2.08297 2.98872 3.26804C1.85165 4.4531 1.13491 5.97857 0.948491 7.6103C0.762075 9.24203 1.11629 10.8899 1.95677 12.3008C2.79725 13.7118 4.07754 14.808 5.60115 15.4211C7.12475 16.0343 8.80746 16.1305 10.391 15.695C11.9746 15.2594 13.3714 14.3163 14.3672 13.0103C15.363 11.7043 15.9027 10.1075 15.9035 8.4652V8.46505C15.9029 7.96192 15.8527 7.46006 15.7535 6.96681C15.7212 6.80664 15.6267 6.66581 15.4908 6.57527C15.3548 6.48473 15.1884 6.45189 15.0282 6.48396Z"
                        fill="#265D91" stroke="#265D91" stroke-width="0.2" />
                    </svg>
                    Re-tester</button>
                  <!--end::Export-->
                  <!--begin::Add customer-->
                  <!--end::Add customer-->
                </div>
                <div class="d-flex justify-content-end revalider mb-3" data-kt-customer-table-toolbar="base">

                  <!--begin::Export-->
                  <button type="button" class="btn btn-light-primary me-3"
                    (click)="dataCandidat('validation','button')">
                    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M7.08446 1.31553L7.08582 1.31552C10.7751 1.31553 13.2476 4.46705 13.2476 7.42001C13.2476 7.57483 13.1855 7.72302 13.0754 7.83206C12.9653 7.94104 12.8164 8.00202 12.6614 8.00202C12.5064 8.00202 12.3575 7.94104 12.2474 7.83206C12.1373 7.72302 12.0752 7.57483 12.0752 7.42001C12.0752 5.03483 10.0669 2.47953 7.08437 2.4781L7.08446 1.31553ZM7.08446 1.31553C6.24363 1.32317 5.41292 1.4983 4.64175 1.83054C3.98531 2.11335 3.38341 2.5051 2.86164 2.98811L2.89308 1.50481C2.89309 1.50477 2.89309 1.50474 2.89309 1.50471C2.89645 1.34993 2.83758 1.20044 2.7299 1.08905C2.62223 0.977689 2.47462 0.913521 2.31963 0.910195C2.16464 0.906869 2.0144 0.964641 1.90201 1.07124C1.78957 1.17789 1.72422 1.32471 1.72084 1.47953L1.72083 1.47962M7.08446 1.31553L1.72083 1.47962M1.72083 1.47962L1.65541 4.55838L1.6554 4.5587M1.72083 1.47962L1.6554 4.5587M1.6554 4.5587C1.6539 4.63726 1.66844 4.71529 1.6981 4.78807C1.72755 4.86033 1.77128 4.9259 1.82663 4.98095C1.88215 5.03806 1.94917 5.08279 2.02323 5.11227C2.09729 5.14175 2.17675 5.15532 2.25641 5.15215L5.36328 5.08594L5.3633 5.08594M1.6554 4.5587L5.3633 5.08594M5.3633 5.08594C5.44007 5.08429 5.5158 5.06768 5.58618 5.03703M5.3633 5.08594L5.58618 5.03703M5.58618 5.03703C5.65656 5.00637 5.72025 4.96223 5.77357 4.90708M5.58618 5.03703L5.77357 4.90708M5.77357 4.90708C5.82689 4.85193 5.86879 4.78684 5.89682 4.71548M5.77357 4.90708L5.89682 4.71548M5.89682 4.71548C5.92485 4.64413 5.93843 4.56795 5.93675 4.49133M5.89682 4.71548L5.93675 4.49133M5.93675 4.49133C5.93508 4.4147 5.91818 4.33919 5.88706 4.26912M5.93675 4.49133L5.88706 4.26912M5.88706 4.26912C5.85595 4.19906 5.81125 4.13584 5.75558 4.08304M5.88706 4.26912L5.75558 4.08304M5.75558 4.08304C5.69992 4.03025 5.63438 3.9889 5.56275 3.9613M5.75558 4.08304L5.56275 3.9613M5.56275 3.9613C5.49111 3.93369 5.41473 3.92035 5.33796 3.922M5.56275 3.9613L5.33796 3.922M5.33796 3.922L5.33799 3.922L5.34118 4.07196C5.39846 4.07073 5.45542 4.08069 5.50881 4.10126C5.5622 4.12184 5.61098 4.15263 5.65236 4.19188L5.33796 3.922ZM5.33796 3.922L3.54147 3.96026M5.33796 3.922L3.54147 3.96026M3.54147 3.96026C4.36861 3.16771 5.60286 2.47812 7.0843 2.4781L3.54147 3.96026Z"
                        fill="#265D91" stroke="#265D91" stroke-width="0.3" />
                      <path
                        d="M7.01165 13.5245L7.01029 13.5245C3.32094 13.5245 0.85 10.3729 0.85 7.41998C0.85 7.26516 0.912108 7.11697 1.02219 7.00794C1.13223 6.89895 1.28116 6.83798 1.43616 6.83798C1.59116 6.83798 1.74009 6.89895 1.85013 7.00794C1.96021 7.11697 2.02232 7.26516 2.02232 7.41998C2.02232 9.80528 4.02934 12.3605 7.01029 12.3605C8.49302 12.3605 9.72742 11.6709 10.5557 10.8783L8.7596 10.9166L8.75957 10.9166L8.75638 10.7666C8.6991 10.7678 8.64214 10.7579 8.58875 10.7373C8.53536 10.7167 8.48658 10.6859 8.4452 10.6467C8.40382 10.6074 8.37065 10.5605 8.34759 10.5086C8.32452 10.4566 8.31201 10.4007 8.31077 10.3439C8.30953 10.2872 8.31958 10.2308 8.34035 10.1779C8.36113 10.125 8.39221 10.0767 8.43184 10.0357C8.47146 9.99474 8.51884 9.96189 8.57129 9.93904C8.62373 9.9162 8.6802 9.90381 8.73748 9.90258L7.01165 13.5245ZM7.01165 13.5245C7.85247 13.5168 8.68319 13.3417 9.45435 13.0095C10.1108 12.7266 10.7127 12.3349 11.2345 11.8519M7.01165 13.5245L11.2345 11.8519M11.2345 11.8519L11.203 13.3353L11.203 13.3354C11.2015 13.412 11.2152 13.4882 11.2433 13.5595L11.3828 13.5045L11.2433 13.5595C11.2714 13.6308 11.3135 13.6959 11.3669 13.7509C11.4203 13.806 11.4841 13.85 11.5545 13.8806C11.6249 13.9111 11.7007 13.9276 11.7775 13.9291L11.7775 13.9291H11.7804H11.7906C11.7906 13.9291 11.7906 13.9291 11.7906 13.9291C11.9436 13.9291 12.0908 13.8698 12.2004 13.7633C12.3101 13.6568 12.3736 13.5117 12.3767 13.3589L12.3767 13.3588L11.2345 11.8519ZM12.2704 9.85711C12.2147 9.80067 12.1478 9.75641 12.074 9.72705C12.0002 9.69769 11.9212 9.68385 11.8418 9.68639C11.8415 9.6864 11.8411 9.68641 11.8408 9.68642L12.2704 9.85711Z"
                        fill="#265D91" stroke="#265D91" stroke-width="0.3" />
                    </svg>
                    Re-valider</button>
                  <!--end::Export-->
                  <!--begin::Add customer-->
                  <!--end::Add customer-->
                </div>
                <div class="d-flex justify-content-end cv mb-3" data-kt-customer-table-toolbar="base">

                  <!--begin::Export-->
                  <button (click)="exportCVCandidate(null, 1, null)" type="button" class="btn btn-light-primary me-3">
                    <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M2.38333 13.1551H10.6167C10.9297 13.1551 11.2396 13.0917 11.5287 12.9685C11.8179 12.8453 12.0806 12.6648 12.3019 12.4371C12.5233 12.2095 12.6988 11.9392 12.8186 11.6418C12.9384 11.3444 13 11.0256 13 10.7037V7.36085C13 7.12443 12.9087 6.89769 12.7462 6.73051C12.5836 6.56334 12.3632 6.46942 12.1333 6.46942C11.9035 6.46942 11.683 6.56334 11.5205 6.73051C11.358 6.89769 11.2667 7.12443 11.2667 7.36085V10.7037C11.2667 10.881 11.1982 11.0511 11.0763 11.1765C10.9544 11.3018 10.7891 11.3723 10.6167 11.3723H2.38333C2.21094 11.3723 2.04561 11.3018 1.92371 11.1765C1.80182 11.0511 1.73333 10.881 1.73333 10.7037V7.36085C1.73333 7.12443 1.64202 6.89769 1.47949 6.73051C1.31696 6.56334 1.09652 6.46942 0.866667 6.46942C0.636812 6.46942 0.416372 6.56334 0.253841 6.73051C0.0913094 6.89769 0 7.12443 0 7.36085V10.7037C0 11.3539 0.2511 11.9774 0.698062 12.4371C1.14502 12.8969 1.75123 13.1551 2.38333 13.1551Z"
                        fill="#265D91" />
                      <path
                        d="M6.49986 0.0600586C6.27001 0.0600586 6.04957 0.153976 5.88704 0.321152C5.7245 0.488327 5.6332 0.715066 5.6332 0.951487V6.56526L4.31586 5.33954C4.14548 5.18085 3.92079 5.09827 3.69121 5.10997C3.46164 5.12167 3.24598 5.2267 3.0917 5.40194C2.93741 5.57719 2.85712 5.8083 2.86849 6.04444C2.87987 6.28057 2.98198 6.50239 3.15236 6.66109L5.9192 9.23509C5.93653 9.25069 5.95386 9.26183 5.9712 9.2752C5.98853 9.28857 6.01236 9.30863 6.03403 9.32423C6.05996 9.34055 6.08672 9.35542 6.1142 9.3688L6.1792 9.40223C6.21035 9.41454 6.24218 9.42496 6.27453 9.43343L6.3352 9.45126C6.44387 9.47395 6.55586 9.47395 6.66453 9.45126L6.7252 9.43343C6.75753 9.42493 6.78936 9.41451 6.82053 9.40223L6.88553 9.3688C6.913 9.35543 6.93977 9.34055 6.9657 9.32423C6.98736 9.30863 7.00686 9.29303 7.02853 9.2752C7.05019 9.25737 7.0632 9.25069 7.08053 9.23509L9.84736 6.66109C9.93173 6.58251 10.0002 6.48761 10.0489 6.3818C10.0976 6.276 10.1256 6.16136 10.1312 6.04444C10.1369 5.92752 10.1201 5.8106 10.0818 5.70036C10.0435 5.59012 9.98443 5.48872 9.90803 5.40194C9.83163 5.31517 9.73937 5.24472 9.6365 5.19463C9.53364 5.14453 9.42218 5.11576 9.30851 5.10997C9.19484 5.10417 9.08116 5.12147 8.97399 5.16086C8.86681 5.20025 8.76823 5.26097 8.68386 5.33954L7.36653 6.56526V0.951487C7.36653 0.715066 7.27522 0.488327 7.11269 0.321152C6.95016 0.153976 6.72972 0.0600586 6.49986 0.0600586Z"
                        fill="#265D91" />
                    </svg>
                    Télécharger CV</button>
                  <!--end::Export-->
                  <!--begin::Add customer-->
                  <!--end::Add customer-->
                </div>
                <div class="d-flex justify-content-end reponse mb-3" data-kt-customer-table-toolbar="base">

                  <!--begin::Export-->
                  <button (click)="downloadFiles('multiple',undefined,'response')" type="button"
                    class="btn btn-light-primary me-3">
                    <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M2.38333 13.1551H10.6167C10.9297 13.1551 11.2396 13.0917 11.5287 12.9685C11.8179 12.8453 12.0806 12.6648 12.3019 12.4371C12.5233 12.2095 12.6988 11.9392 12.8186 11.6418C12.9384 11.3444 13 11.0256 13 10.7037V7.36085C13 7.12443 12.9087 6.89769 12.7462 6.73051C12.5836 6.56334 12.3632 6.46942 12.1333 6.46942C11.9035 6.46942 11.683 6.56334 11.5205 6.73051C11.358 6.89769 11.2667 7.12443 11.2667 7.36085V10.7037C11.2667 10.881 11.1982 11.0511 11.0763 11.1765C10.9544 11.3018 10.7891 11.3723 10.6167 11.3723H2.38333C2.21094 11.3723 2.04561 11.3018 1.92371 11.1765C1.80182 11.0511 1.73333 10.881 1.73333 10.7037V7.36085C1.73333 7.12443 1.64202 6.89769 1.47949 6.73051C1.31696 6.56334 1.09652 6.46942 0.866667 6.46942C0.636812 6.46942 0.416372 6.56334 0.253841 6.73051C0.0913094 6.89769 0 7.12443 0 7.36085V10.7037C0 11.3539 0.2511 11.9774 0.698062 12.4371C1.14502 12.8969 1.75123 13.1551 2.38333 13.1551Z"
                        fill="#265D91" />
                      <path
                        d="M6.49986 0.0600586C6.27001 0.0600586 6.04957 0.153976 5.88704 0.321152C5.7245 0.488327 5.6332 0.715066 5.6332 0.951487V6.56526L4.31586 5.33954C4.14548 5.18085 3.92079 5.09827 3.69121 5.10997C3.46164 5.12167 3.24598 5.2267 3.0917 5.40194C2.93741 5.57719 2.85712 5.8083 2.86849 6.04444C2.87987 6.28057 2.98198 6.50239 3.15236 6.66109L5.9192 9.23509C5.93653 9.25069 5.95386 9.26183 5.9712 9.2752C5.98853 9.28857 6.01236 9.30863 6.03403 9.32423C6.05996 9.34055 6.08672 9.35542 6.1142 9.3688L6.1792 9.40223C6.21035 9.41454 6.24218 9.42496 6.27453 9.43343L6.3352 9.45126C6.44387 9.47395 6.55586 9.47395 6.66453 9.45126L6.7252 9.43343C6.75753 9.42493 6.78936 9.41451 6.82053 9.40223L6.88553 9.3688C6.913 9.35543 6.93977 9.34055 6.9657 9.32423C6.98736 9.30863 7.00686 9.29303 7.02853 9.2752C7.05019 9.25737 7.0632 9.25069 7.08053 9.23509L9.84736 6.66109C9.93173 6.58251 10.0002 6.48761 10.0489 6.3818C10.0976 6.276 10.1256 6.16136 10.1312 6.04444C10.1369 5.92752 10.1201 5.8106 10.0818 5.70036C10.0435 5.59012 9.98443 5.48872 9.90803 5.40194C9.83163 5.31517 9.73937 5.24472 9.6365 5.19463C9.53364 5.14453 9.42218 5.11576 9.30851 5.10997C9.19484 5.10417 9.08116 5.12147 8.97399 5.16086C8.86681 5.20025 8.76823 5.26097 8.68386 5.33954L7.36653 6.56526V0.951487C7.36653 0.715066 7.27522 0.488327 7.11269 0.321152C6.95016 0.153976 6.72972 0.0600586 6.49986 0.0600586Z"
                        fill="#265D91" />
                    </svg>
                    Télécharger Réponses</button>
                  <!--end::Export-->
                  <!--begin::Add customer-->
                  <!--end::Add customer-->
                </div>
                <div class="d-flex justify-content-end export mb-3" data-kt-customer-table-toolbar="base">

                 
                  <button (click)="exportCandidats()" type="button" class="btn btn-light-primary me-3">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M5.85909 10.3268C5.29968 10.3268 4.74027 10.1071 4.31335 9.68234C3.45951 8.83288 3.45951 7.45618 4.31335 6.59207L7.94952 2.97455H2.56151C1.14826 2.97455 0 4.11692 0 5.52292V11.4106C0 12.8166 1.14826 13.9589 2.56151 13.9589H8.47949C9.89274 13.9589 11.041 12.8166 11.041 11.4106V6.07947L7.40483 9.69699C6.97791 10.1217 6.4185 10.3268 5.85909 10.3268Z"
                        fill="#265D91" />
                      <path
                        d="M13.1904 0.0600586H8.53843C8.09679 0.0600586 7.74347 0.411559 7.74347 0.850934C7.74347 1.29031 8.09679 1.64181 8.53843 1.64181H11.2913L5.29973 7.58802C4.99058 7.89558 4.99058 8.39354 5.29973 8.7011C5.44695 8.84756 5.65304 8.93544 5.85914 8.93544C6.06524 8.93544 6.25662 8.86221 6.41855 8.7011L12.4101 2.74025V5.47902C12.4101 5.91839 12.7634 6.2699 13.2051 6.2699C13.6467 6.2699 14 5.91839 14 5.47902V0.850934C13.9853 0.411559 13.632 0.0600586 13.1904 0.0600586Z"
                        fill="#265D91" />
                    </svg>
                    Exporter </button>
                  <!--end::Export-->
                  <!--begin::Add customer-->
                  <!--end::Add customer-->
                </div>
                <!--end::Toolbar-->

              </div>
              <!--end::Card toolbar-->
            </div>
            <!--end::Card header buttons-->
            <!--begin::Card body-->
            <div class="tab-content">
              <div id="grid" class="tab-pane fade active show">
                <!--begin::Row-->
                <div>

                  <div class="row g-6 g-xl-9 cards" style="justify-content: center;">
                    <!--begin::Col-->
                    <div class="col-sm-6 col-xl-4" *ngFor="let cardCandidat of listCandidats; let i =index"
                      (click)="toggleRowSelection(cardCandidat)">
                      <!--begin::Card-->
                      <div class="card h-100">
                        <div class="form-check" style="margin: 17px;">
                          <input [checked]="headerChecked"
                            (change)="changeSelectCandidats($event,'single',cardCandidat)" class="form-check-input"
                            type="checkbox" value="" id="flexCheckDefault" />
                        </div>
                        <div class="card-toolbar m-0">

                          <!-- *********************************************************************** -->
                          <!-- begin menu action -->
                          <div class="tools mb-5">
                            <div class="dropdown">
                              <button
                                class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                                type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true"
                                aria-expanded="false">
                                <svg width="19" height="5" viewBox="0 0 19 5" fill="none"
                                  xmlns="http://www.w3.org/2000/svg">
                                  <circle cx="2.44739" cy="2.44739" r="2.44739" transform="matrix(1 0 0 -1 0 4.89478)"
                                    fill="#265D91" />
                                  <circle cx="2.44739" cy="2.44739" r="2.44739"
                                    transform="matrix(1 0 0 -1 6.85254 4.89478)" fill="#265D91" />
                                  <circle cx="2.44739" cy="2.44739" r="2.44739"
                                    transform="matrix(1 0 0 -1 13.7061 4.89478)" fill="#265D91" />
                                </svg>
                              </button>
                              <div class="dropdown-menu " aria-labelledby="dropdownMenuButton">
                                <a class="dropdown-item " (click)="navigateToProfilCandidat(cardCandidat.uuid)">Voir
                                  Profil</a>
                                <a class="dropdown-item "
                                  (click)="dataCandidat('validation','row',cardCandidat)">Re-valider</a>
                                <a class="dropdown-item "
                                  (click)="dataCandidat('test','row',cardCandidat)">Re-tester</a>
                              </div>
                            </div>
                          </div>
                          <!-- end menu action -->
                          <!-- *********************************************************************** -->
                        </div>
                        <!--begin::Card header-->
                        <!--begin::Card header-->
                        <div class="card-header start-align flex-nowrap border-0 pt-9">
                          <!--begin::Card title-->
                          <div class="card-title mt-10">
                            <!--begin::Icon-->

                            <!--end::Icon-->
                            <!--begin::Title-->
                            <a class="name mb-5 cursor-pointer" style="margin-top: -25px;"
                              [routerLink]="['/acceuil/candidats/profil-candidat', { idCandidat: cardCandidat.uuid }]">{{cardCandidat.first_name}} {{cardCandidat.last_name}} 
                            </a>
                            <!--end::Title-->
                            <div class="infos">
                              <p class="sub-info">Poste :
                                {{cardCandidat.desired_workstation && cardCandidat.desired_workstation!='null' ? cardCandidat.desired_workstation:'---'}}</p>
                                <p *ngIf="cardCandidat.desired_salary&&cardCandidat.desired_salary!='null'&&cardCandidat.desired_salary!=='0'" class="sub-info">Salaire :{{cardCandidat.desired_salary +'€'}}</p>
                                <p *ngIf="cardCandidat.tjm&&cardCandidat.tjm!='null'&&cardCandidat.tjm!=='0'" class="sub-info">TJM : {{cardCandidat.tjm +' €'}}</p>
                              <p class="sub-info">Année d’expérience :
                                {{cardCandidat.years_of_experience?cardCandidat.years_of_experience:'---'}}</p>
                            </div>
                          </div>
                        </div>
                        <!--end::Card header-->
                        <!--begin::Card body-->
                        <div class="card-body d-flex flex-column px-9 pt-6 pb-8">
                          <div class="footer d-flex fw-semibold">
                            <div class="details">
                              <a class="cursor-pointer" (click)="navigateToProfilCandidat(cardCandidat.uuid)">Voir
                                détail</a>
                            </div>
                          </div>
                          <!--end::Indicator-->
                        </div>
                        <!--end::Card body-->
                        <!--end::Card body-->
                      </div>
                      <!--end::Card-->
                    </div>
                    <!--end::Col-->
                  </div>

                </div>

                <!--end::Row-->

              </div>
            
            </div>
            <div class="alert alert-warning text-center mt-5" role="alert"
              *ngIf="!listCandidats.length && !loadSpinnerTable">
              <img src="/assets/media/logos/logo-no-data.png" alt="" class="mb-5">
              <span class="empty-list">
                La liste est vide
              </span>
            </div>
            <div class="pagination" *ngIf="listCandidats && listCandidats.length">
              <app-pagination [data]="listCandidats" [lengthData]="totalItems" [currentPageList]="currentPage"
                (setPages)="getItems($event)"> </app-pagination>
            </div>
          </div>
          <!-- -->
          <!--end::Card-->
          <!--begin::Modals-->
          <!--begin::Modal - Customers - Add-->

          <!--end::Modal - Customers - Add-->
          <!--begin::Modal - Adjust Balance-->


          <!--end::Modal - New Card-->
          <!--end::Modals-->
        </div>
        <!--end::Content container-->
      </div>
      <!--end::Content-->
    </div>
    <!--end::Content wrapper-->
    <!--begin::Footer-->

    <!--end::Footer-->
    <!--end:::Main-->
  </div>
  <ng-template #add_candidat>
    <div class="modal-content" id="add_candidat" tabindex="-1" aria-hidden="true">
      <!--begin::Modal dialog-->
      <!--begin::Modal content-->
      <div class=" modal-dialog-centered">
        <!--begin::Modal content-->
        <div class="content">
          <!--begin::Modal header-->
          <div class="modal-header">
            <!--begin::Modal title-->
            <h2 class="">Ajouter candidat</h2>
            <!--end::Modal title-->
            <!--begin::Close-->
            <div id="kt_customers_export_close" data-bs-dismiss="modal"
              class="btn btn-icon btn-sm btn-active-icon-primary">
              <i class="ki-duotone ki-cross fs-1" (click)="closeModal()">
                <span class="path1"></span>
                <span class="path2"></span>
              </i>
            </div>
            <!--end::Close-->
          </div>
          <!--end::Modal header-->
          <!--begin::Modal body-->
          <div class="modal-body scroll-y mx-5 mx-xl-15 my-7">
          
            <form id="kt_customers_export_form" [formGroup]="addCandidateFormGroup" class="form">
              <!--begin::Input group-->

              <div class="row">
                <div class="col-lg-6">
                  <div class="content">
                    <div class="lastname mb-5">

                      <label for="prenom" class="required form-label">Prénom</label>
                      <input type="text" formControlName="first_name" class="form-control mb-3" placeholder="Prénom" />
                      <app-feild-error [control]="addCandidateFormGroup.get('first_name')"></app-feild-error>

                    </div>
                    <div class="name mb-5">

                      <label for="nom" class="required form-label">Nom</label>
                      <input type="text" formControlName="last_name" class="form-control   mb-3" placeholder="Nom" />
                      <app-feild-error [control]="addCandidateFormGroup.get('last_name')"></app-feild-error>


                    </div>
                    <!--begin::Label-->
                 


                    <div class="mb-5">
                      <label for="Email" class="required form-label">Email personnel</label>
                      <input type="email" formControlName="email" class="form-control   mb-3"
                        placeholder="Email personnel" />
                      <app-feild-error [control]="addCandidateFormGroup.get('email')"
                        [controlName]="'email'"></app-feild-error>
                    </div>
                    <div class="mb-5 d-flex flex-column">
                      <label for="N° Tel" class="form-label">N° Tel</label>
                      <intl-telephone-input 
                        #phoneInput
                        [preferredCountries]="[CountryISO.France, CountryISO.Tunisia]" 
                        [enablePlaceholder]="true"
                        [searchCountryFlag]="true" 
                        [separateDialCode]="false" 
                        [enableAutoCountrySelect]="true"
                        [searchCountryField]="SearchCountryField.All" 
                        [phoneValidation]="true"
                        [numberFormat]="PhoneNumberFormat.International" 
                        [inputId]="'phone'" 
                        [maxLength]="14"
                        [searchCountryPlaceholder]="'Rechercher un pays'" 
                        (onChange)="handlePhoneNumberInput($event)" 
                        (countryChange)="handleCountryChange($event)" 
                        (countrySearch)="handleCountrySearch($event)"
                        formControlName="phone_number">
                      </intl-telephone-input>
                  
                      <app-feild-error [control]="addCandidateFormGroup.get('phone_number')"></app-feild-error>
                    </div>
                                   
                    <div class="mb-5">
                      <label for="Pays" class=" form-label">Pays de résidence actuel</label>
                      <ng-select formControlName="current_country" [items]="paysList" bindLabel="name" bindValue="name"
                        [placeholder]="'Pays de résidence actuel'" [notFoundText]="'Aucun élément trouvé'"  autoComplete>
                      </ng-select>
                      <app-feild-error [control]="addCandidateFormGroup.get('current_country')"></app-feild-error>
                    </div>
                    <div class="mb-5">
                      <label for="Pays" class=" form-label">Pays destinataire</label>
                      <ng-select formControlName="destination_country" (change)="onCountryChange('add')"
                        [items]="paysList" [multiple]="true" bindLabel="name" [notFoundText]="'Aucun élément trouvé'" bindValue="name"
                        [placeholder]="'Pays destinataire'" autoComplete>
                        <ng-template ng-optgroup-tmp let-item="item">
                          {{ item.name || 'Unnamed group' }}
                        </ng-template>
                      </ng-select>
                      <app-feild-error [control]="addCandidateFormGroup.get('destination_country')"></app-feild-error>
                    </div>
                    <div class="mb-5">
                      <label for="Mobilité" class=" form-label">Mobilité</label>
                      <ng-select formControlName="mobility" (change)="onMobilityChange('add')" [items]="stateList"
                        [multiple]="true" bindLabel="name" bindValue="name" [placeholder]="'Mobilité'" [notFoundText]="'Aucun élément trouvé'" autoComplete>
                      </ng-select>
                      <app-feild-error [control]="addCandidateFormGroup.get('mobility')"></app-feild-error>
                    </div>
                    <div class="mb-5 mt-5">
                      <label for="disponibilite" class=" form-label">Disponibilité</label>
                      <ng-select formControlName="availability" [items]="disponibilite" bindLabel="name" [notFoundText]="'Aucun élément trouvé'" bindValue="id"
                        [placeholder]="'Immédiate'" autoComplete>
                      </ng-select>
                      <app-feild-error [control]="addCandidateFormGroup.get('availability')"></app-feild-error>
                    </div>
                    <div class="mb-5 calenderDate" *ngIf="!experience">
                      <label for="date-first-exp" class="form-label">Date de la première expérience</label>
                    

                      <p-calendar [style]="{'border': 'none','margin-top': '-6px'}" dateFormat="dd/mm/yy" 
                      placeholder="Date de la première expérience"  (change)="selectDate();calculateExperience()"
                      formControlName="date_first_experience"  class="form-control mb-3"
                         ></p-calendar>
                    </div>
                    <div class="desclaimer mt-4 mb-5" *ngIf="isChosenDateValid">
                      <span class="error-message">La date sélectionnée est dans le futur, il faut choisir une autre date</span>
                    </div>
                    <div class="mb-5">
                      <div class="form-check">
                        <label for="date-first-exp" class="form-label">Aucune expérience</label>
                        <input 
                          class="form-check-input checkbox-border" 
                          type="checkbox"
                          (change)="changeExperience($event)" 
                          [checked]="experience" 
                          id="flexCheckDefault" 
                        />
                      </div>
                    </div>
                    

                
                    <div class="mb-5">
                      <div class="form-check">
                        <input class="form-check-input checkbox-border"
                          [checked]="addCandidateFormGroup.get('open_for_mission')?.value"
                          formControlName="open_for_mission" type="checkbox" (change)="changeMission($event)" value=""
                          id="flexCheckDefault" />
                        <label class="form-label" for="flexRadioLg">
                          Ouvert pour une nouvelle mission
                        </label>
                      </div>
                    </div>
                    <!--end::Input-->
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="content">
                    <div class="mb-5">
                      <label for="Pays" class=" form-label">Compétences</label>
                      <ng-select formControlName="skills" [items]="skillsList" bindLabel="name_FR" [notFoundText]="'Aucun élément trouvé'" bindValue="id"
                        [multiple]="true" [placeholder]="'Compétences'" autoComplete>
                      </ng-select>
                      <app-feild-error [control]="addCandidateFormGroup.get('skills')"></app-feild-error>
                    </div>
                    <!-- diplomes -->
                    <div class="mb-5" formArrayName="diplome">
                      <div class="d-flex justify-content-between align-items-center">
                        <label for="diplome" class=" form-label">Diplôme</label>
                        <button class="more-label" [disabled]="diplome.controls[0].value.name == ''"
                          (click)="addDiplome()">
                          <img src="/assets/media/icons/icon-add.png" alt="" width="25px" class="cursor-pointer">
                        </button>

                      </div>
                      <div class="more-diplome " *ngFor="let diplome of diplome.controls; let i = index">
                        <div [formGroupName]="i">
                          <img *ngIf="i>0" src="/assets/media/icons/icon-delete.png" alt="" width="25px"
                            class="cursor-pointer remove-diplome" (click)="removeDiplome(i)">
                          <input type="text" formControlName="name" class="form-control mb-3"
                            placeholder="ajouter un diplôme" id="diplome">
                          <app-feild-error [control]="diplome.get('name')"></app-feild-error>
                        </div>
                      </div>
                    </div>
                    <!-- certificat -->
                    <div class="mb-5" formArrayName="certificat">
                      <div class="d-flex justify-content-between align-items-center">
                        <label for="certification" class="form-label">Certification</label>
                        <button class="more-label" [disabled]="!addCandidateFormGroup.valid"
                          (click)="addCertification()" [disabled]="certificat.controls[0].value?.name == ''">
                          <img src="/assets/media/icons/icon-add.png" alt="" width="25px" class="cursor-pointer">
                        </button>
                      </div>

                      <div class="more-certif" *ngFor="let certif of certificat.controls; let j = index">
                        <div [formGroupName]="j">
                          <img *ngIf="j>0" src="/assets/media/icons/icon-delete.png" alt="" width="25px"
                            class="cursor-pointer remove-diplome" (click)="removeCertification(j)">
                          <input type="text" name="certification" formControlName="name" id="certification"
                            class="form-control mb-3" placeholder="ajouter une certification">
                          <app-feild-error [control]="certif.get('name')"></app-feild-error>
                        </div>
                      </div>
                    </div>
                    <!--  -->
                    <div class="mb-5">
                      <label for="Pays" class=" form-label">Contrat souhaité</label>
                      <ng-select formControlName="desired_contract" [items]="contratRequest" bindLabel="label"
                        [multiple]="true" bindValue="id" [placeholder]="'Contrat souhaité'" [notFoundText]="'Aucun élément trouvé'" autoComplete>
                      </ng-select>
                      <app-feild-error [control]="addCandidateFormGroup.get('desired_contract')"></app-feild-error>
                    </div>
                    <div class="mb-5">
                      <label for="tjm" class=" form-label">TJM</label>
                      <input formControlName="tjm" type="text" (keypress)="keyPress($event)" name="tjm" id="tjm"
                        class="form-control mb-3" placeholder="TJM" autoComplete>
                      <app-feild-error [control]="addCandidateFormGroup.get('tjm')"></app-feild-error>
                    </div>

                    <div class="mb-5">
                      <label for="nom" class=" form-label">Poste</label>
                      <input autoComplete formControlName="desired_workstation" name="poste" id="poste" type="text"
                        class="form-control mb-3" placeholder="Poste souhaité" />
                      <app-feild-error [control]="addCandidateFormGroup.get('desired_workstation')"></app-feild-error>
                    </div>
                    <div class="mb-5">
                      <label for="nom" class=" form-label">Salaire souhaité</label>
                      <input autoComplete formControlName="desired_salary" (keypress)="keyPress($event)" name="salary"
                        id="salary" type="text" class="form-control mb-3" placeholder="30000 €" />
                      <app-feild-error [control]="addCandidateFormGroup.get('desired_salary')"></app-feild-error>
                    </div>
                    <div class="mb-5">
                      <div class="d-flex justify-content-between">
                        <label for="cv" class="form-label">Importer CV</label>
                        <button *ngIf="fileName!=''" class="more-label" (click)="resetCV()">
                          <img src="/assets/media/icons/icon-delete.png" alt="" width="30px" class="cursor-pointer">
                        </button>
                      </div>
                      <label for="fileInput" class="custom-file-input-label" style="display:none">
                        <a>Choisir un fichier</a>
                      </label>
                      <input formControlName="cv" id="fileInput" #inputFile type="file" name="cv"
                        (change)="uploadFile($event); setValidatorRequirements()" class="form-control mb-3">
                      <span style="color:red" *ngIf="fileError"><small>{{fileError}} </small></span>
                      <span style="color:red" *ngIf="fileExtention"><small>{{fileExtention}} </small></span>
                      <app-feild-error [control]="addCandidateFormGroup.get('cv')"></app-feild-error>
                    </div>
                    
                    <div class="mb-5">
                      <label for="nom" class="form-label">LinkedIn</label>
                      <input type="text" name="linkedin" class="form-control mb-3"
                        (input)="setValidatorRequirements()" id="linkedin" placeholder="https://www.linkedin.com/in/"
                        formControlName="linkedin_link">
                      <app-feild-error [control]="addCandidateFormGroup.get('linkedin_link')"></app-feild-error>
                    </div>
                    
                    <!-- <div class="mb-5">
                      <div class="d-flex justify-content-between">
                        <label for="cv" class=" form-label">Importer CV</label>
                        <button *ngIf="fileName!=''" class="more-label" (click)="resetCV()">
                          <img src="/assets/media/icons/icon-delete.png" alt="" width="30px" class="cursor-pointer">
                        </button>
                      </div>
                      <label for="fileInput" class="custom-file-input-label" style="display:none"> <a>Choisir un fichier
                        </a> </label>
                      <input formControlName="cv" id="fileInput" #inputFile type="file" name="cv" id="cv"
                        (change)="uploadFile($event);setValidatorRequirements()" class="form-control mb-3">
                      <span style="color:red" *ngIf="fileError"><small>{{fileError}} </small></span>
                      <span style="color:red" *ngIf="fileExtention"><small>{{fileExtention}} </small></span>
                      <app-feild-error [control]="addCandidateFormGroup.get('cv')"></app-feild-error>

                    </div>
                    <div class="mb-5">
                      <label for="nom" class=" form-label">Linkedin</label>
              
                        <input type="text" name="linkedin" class="form-control mb-3"
                          (change)="setValidatorRequirements()" id="linkedin" placeholder="https://www.linkedin.com/in/"
                          formControlName="linkedin_link">
               
                   
                      <app-feild-error [control]="addCandidateFormGroup.get('linkedin_link')"></app-feild-error>
                    </div> -->
                    <span class="requirements mt-5"> <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_379_198)">
                          <path
                            d="M8 16C9.58225 16 11.129 15.5308 12.4446 14.6518C13.7602 13.7727 14.7855 12.5233 15.391 11.0615C15.9965 9.59966 16.155 7.99113 15.8463 6.43928C15.5376 4.88743 14.7757 3.46197 13.6569 2.34315C12.538 1.22433 11.1126 0.462403 9.56072 0.153721C8.00887 -0.15496 6.40034 0.00346629 4.93853 0.608967C3.47672 1.21447 2.22729 2.23985 1.34824 3.55544C0.469192 4.87104 0 6.41775 0 8C0.00229405 10.121 0.845886 12.1545 2.34568 13.6543C3.84547 15.1541 5.87897 15.9977 8 16ZM8 3.33334C8.19778 3.33334 8.39112 3.39199 8.55557 3.50187C8.72002 3.61175 8.84819 3.76793 8.92388 3.95065C8.99957 4.13338 9.01937 4.33445 8.98079 4.52843C8.9422 4.72241 8.84696 4.90059 8.70711 5.04044C8.56726 5.1803 8.38907 5.27554 8.19509 5.31412C8.00111 5.35271 7.80004 5.3329 7.61732 5.25722C7.43459 5.18153 7.27841 5.05336 7.16853 4.88891C7.05865 4.72446 7 4.53112 7 4.33334C7 4.06812 7.10536 3.81377 7.29289 3.62623C7.48043 3.43869 7.73478 3.33334 8 3.33334ZM7.33333 6.66667H8C8.35362 6.66667 8.69276 6.80715 8.94281 7.0572C9.19286 7.30724 9.33333 7.64638 9.33333 8V12C9.33333 12.1768 9.2631 12.3464 9.13807 12.4714C9.01305 12.5964 8.84348 12.6667 8.66667 12.6667C8.48986 12.6667 8.32029 12.5964 8.19526 12.4714C8.07024 12.3464 8 12.1768 8 12V8H7.33333C7.15652 8 6.98695 7.92977 6.86193 7.80474C6.73691 7.67972 6.66667 7.51015 6.66667 7.33334C6.66667 7.15653 6.73691 6.98696 6.86193 6.86193C6.98695 6.73691 7.15652 6.66667 7.33333 6.66667Z"
                            fill="#2b5d8f" />
                        </g>
                        <defs>
                          <clipPath id="clip0_379_198">
                            <rect width="16" height="16" fill="white" />
                          </clipPath>
                        </defs>
                      </svg> &nbsp;Au moins l'un des champs CV ou LinkedIn est requis.</span>
                  </div>
                </div>
              </div>


            </form>
            <div class="modal-footer">
              <button type="reset" (click)="closeModal()" id="kt_customers_export_cancel" data-bs-dismiss="modal"
                class="footer-btn annuler me-3">Annuler</button>
              <button [disabled]="fileError!='' || fileExtention!='' || isChosenDateValid "  type="submit"
                id="kt_customers_export_submit" (click)="addCandidat()" class="footer-btn confirmer ">
                <span class="indicator-label">Confirmer</span>
                <span class="indicator-progress">Please wait...
                  <span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>
              </button>
            </div>
            <!--end::Form-->
          </div>
          <!--end::Modal body-->
        </div>
      </div>
    </div>
    <!--end::Modal content-->
    <!--end::Modal dialog-->
  </ng-template>
  <ng-template #add_masse>
    <div class="modal-content" id="add_masse" tabindex="-1" aria-hidden="true">
      <!--begin::Modal dialog-->
      <!--begin::Modal content-->
      <div class="">
        <!--begin::Modal content-->
        <div class="content">
          <!--begin::Modal header-->
          <div class="modal-header">
            <!--begin::Modal title-->
            <h2 class="">Ajouter en masse</h2>
            <!--end::Modal title-->
            <!--begin::Close-->
            <div id="kt_customers_export_close" data-bs-dismiss="modal"
              class="btn btn-icon btn-sm btn-active-icon-primary">
              <i class="ki-duotone ki-cross fs-1" (click)="closeModal()">
                <span class="path1"></span>
                <span class="path2"></span>
              </i>
            </div>
            <!--end::Close-->
          </div>
          <!--end::Modal header-->
          <!--begin::Modal body-->
          <div class="modal-body scroll-y mx-5 mx-xl-15 my-7">
          
            <label for="masse">Votre ficher CSV</label>
            <input type="file" name="masse" id="masse" class="form-control" (change)="onFileSelected($event)">
            <span class="error mt-5">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_379_198)">
                  <path
                    d="M8 16C9.58225 16 11.129 15.5308 12.4446 14.6518C13.7602 13.7727 14.7855 12.5233 15.391 11.0615C15.9965 9.59966 16.155 7.99113 15.8463 6.43928C15.5376 4.88743 14.7757 3.46197 13.6569 2.34315C12.538 1.22433 11.1126 0.462403 9.56072 0.153721C8.00887 -0.15496 6.40034 0.00346629 4.93853 0.608967C3.47672 1.21447 2.22729 2.23985 1.34824 3.55544C0.469192 4.87104 0 6.41775 0 8C0.00229405 10.121 0.845886 12.1545 2.34568 13.6543C3.84547 15.1541 5.87897 15.9977 8 16ZM8 3.33334C8.19778 3.33334 8.39112 3.39199 8.55557 3.50187C8.72002 3.61175 8.84819 3.76793 8.92388 3.95065C8.99957 4.13338 9.01937 4.33445 8.98079 4.52843C8.9422 4.72241 8.84696 4.90059 8.70711 5.04044C8.56726 5.1803 8.38907 5.27554 8.19509 5.31412C8.00111 5.35271 7.80004 5.3329 7.61732 5.25722C7.43459 5.18153 7.27841 5.05336 7.16853 4.88891C7.05865 4.72446 7 4.53112 7 4.33334C7 4.06812 7.10536 3.81377 7.29289 3.62623C7.48043 3.43869 7.73478 3.33334 8 3.33334ZM7.33333 6.66667H8C8.35362 6.66667 8.69276 6.80715 8.94281 7.0572C9.19286 7.30724 9.33333 7.64638 9.33333 8V12C9.33333 12.1768 9.2631 12.3464 9.13807 12.4714C9.01305 12.5964 8.84348 12.6667 8.66667 12.6667C8.48986 12.6667 8.32029 12.5964 8.19526 12.4714C8.07024 12.3464 8 12.1768 8 12V8H7.33333C7.15652 8 6.98695 7.92977 6.86193 7.80474C6.73691 7.67972 6.66667 7.51015 6.66667 7.33334C6.66667 7.15653 6.73691 6.98696 6.86193 6.86193C6.98695 6.73691 7.15652 6.66667 7.33333 6.66667Z"
                    fill="#2b5d8f" />
                </g>
                <defs>
                  <clipPath id="clip0_379_198">
                    <rect width="16" height="16" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              Les champs "mail", "nom" et "prénom" sont obligatoires. Fournir un lien LinkedIn ou un CV. La photo et le CV doivent être des URLs.
            </span>
            <span style="color:red" *ngIf="fileExtentions"><small>{{fileExtentions}} </small></span>

            <div class="modal-footer">
              <button type="reset" (click)="closeModal()" id="kt_customers_export_cancel" data-bs-dismiss="modal"
                class="footer-btn annuler me-3">Annuler</button>
              <button [disabled]="fileExtentions!='' || !selectedFile" type="submit" id="kt_customers_export_submit"
                (click)="addBulkCandidates()" class="footer-btn confirmer ">
                <span class="indicator-label">Confirmer</span>
                <span class="indicator-progress">Please wait...
                  <span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>
              </button>
            </div>
            <!--end::Form-->
          </div>
          <!--end::Modal body-->
        </div>
      </div>
    </div>
  </ng-template>
